"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utf = _interopRequireDefault(require("utf8"));
var _buffer = require("buffer");
var _asyncStorage = _interopRequireDefault(require("@react-native-async-storage/async-storage"));
var _delay = _interopRequireDefault(require("delay"));
var _axios = _interopRequireDefault(require("axios"));
var _apis = _interopRequireDefault(require("@sart/apis"));
var _content = _interopRequireDefault(require("@sart/content"));
var _utilities = require("@sart/utilities");
var _config = _interopRequireDefault(require("./config"));
require("regenerator-runtime/runtime");
var _utils = require("./utils");
var _validations = require("./validations");
var _cache = _interopRequireWildcard(require("./cache"));
var _excluded = ["basketUserId", "basketId", "promoPlans", "selectedPlan", "customerDetails", "cardDetails", "cachedPayment", "referralcode"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t60 in e) "default" !== _t60 && {}.hasOwnProperty.call(e, _t60) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t60)) && (i.get || i.set) ? o(f, _t60, i) : f[_t60] = e[_t60]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //IMPORTANT: DO NOT DELETE THIS LINE!
//The import is used at run-time on the ConsumerPortal and the
//release process for the portal breaks without it.
//Again: DO NOT REMOVE THE BELOW LINE
var postpaidSignUpLegId = "VADSA-POSTPAID-CUST-SIGNUP";
var prepaidSignUpLegId = "VADSA-PREPAID-CUST-SIGNUP";
var appSignUpLegId = "VADSA-NCA-APP-CUST-SIGNUP";
var dispatchSimLegacyId = "VADSA-DISPATCH-SIM";
var dispatchESimLegacyId = "VADSA-DISPATCH-E-SIM";
var assignSimLegacyId = "VADSA-ASSIGN-SIM";
var registerUserLegacyId = "VADSA-REGISTER-USER";
var prepaidBillingMode = "PREPAID";
var clientVersion = "V2.0.36";
var basePrepaidPlan = "PAYG";
var eliotSignUpLegacyId = "ELIOT-PREPAID-CUST-SIGNUP";
var Client = exports["default"] = /*#__PURE__*/function () {
  function Client() {
    (0, _classCallCheck2["default"])(this, Client);
  }
  return (0, _createClass2["default"])(Client, null, [{
    key: "setupApi",
    value: function setupApi(api) {
      this.api = api instanceof _apis["default"].ApiClient ? api : new _apis["default"].ApiClient();
      this.setHeaders({
        Version: clientVersion
      });
    }
  }, {
    key: "setApiBasePath",
    value: function setApiBasePath(basePath) {
      if (this.api !== null && this.api !== undefined && this.api instanceof _apis["default"].ApiClient) {
        this.api.basePath = basePath;
      }
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(obj) {
      this.api.defaultHeaders = _objectSpread(_objectSpread({}, this.api.defaultHeaders), obj);
    }

    // Configurating (permanent per app)
  }, {
    key: "setConfiguration",
    value: function setConfiguration(configuration) {
      this.configuration = configuration;
    }
  }, {
    key: "getConfiguration",
    value: function getConfiguration() {
      return this.configuration;
    }

    // Caching (temporary per user session)
  }, {
    key: "cache",
    get: function get() {
      return _cache["default"].getState();
    }

    // static initCache() {
    //   cache.init()
    // }
  }, {
    key: "setCache",
    value: function setCache(obj) {
      (0, _cache.addToCache)(obj);
    }
  }, {
    key: "replaceCache",
    value: function replaceCache(obj) {
      (0, _cache.replaceCache)(obj);
    }
  }, {
    key: "unsetCache",
    value: function unsetCache(key) {
      (0, _cache.removeFromCache)(key);
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      (0, _cache.clearCache)();
    }
  }, {
    key: "clearBasketCache",
    value: function clearBasketCache(obj) {
      var _this$cache = this.cache,
        basketUserId = _this$cache.basketUserId,
        basketId = _this$cache.basketId,
        promoPlans = _this$cache.promoPlans,
        selectedPlan = _this$cache.selectedPlan,
        customerDetails = _this$cache.customerDetails,
        cardDetails = _this$cache.cardDetails,
        cachedPayment = _this$cache.cachedPayment,
        referralcode = _this$cache.referralcode,
        rest = (0, _objectWithoutProperties2["default"])(_this$cache, _excluded);
      this.replaceCache(_objectSpread(_objectSpread({}, rest), obj));
    }
  }, {
    key: "isPostpaid",
    get: function get() {
      return this.cache.billingMode === 'POSTPAID';
    }
  }, {
    key: "isPrepaid",
    get: function get() {
      return this.cache.billingMode === 'PREPAID';
    }
  }, {
    key: "encodeCredentials",
    value: function encodeCredentials(string) {
      var safeString = _utf["default"].encode(string);
      var base64EncodedString = _buffer.Buffer.from(safeString).toString('base64');
      return base64EncodedString;
    }
  }, {
    key: "setupHeaderBasicAuth",
    value: function setupHeaderBasicAuth(_ref) {
      var username = _ref.username,
        password = _ref.password;
      // Validate Fields
      if (!(0, _validations.validatePassword)(password)) {
        throw new Error(_content["default"].forms.passwordInvalid);
      }
      try {
        var credentials = username + ':' + password;
        var encodedCredentials = this.encodeCredentials(credentials);
        this.setHeaders({
          Authorization: 'Basic ' + encodedCredentials
        });
      } catch (error) {
        throw error;
      }
    }
  }, {
    key: "setupHeaderStoredBasicAuth",
    value: function setupHeaderStoredBasicAuth(auth) {
      try {
        this.setHeaders({
          Authorization: 'Basic ' + auth
        });
      } catch (error) {
        throw error;
      }
    }
  }, {
    key: "setupHeaderBearerAuth",
    value: function setupHeaderBearerAuth(token) {
      try {
        if (!(0, _validations.validateToken)(token)) {
          throw new Error(_content["default"].login.validateToken);
        }
        this.setHeaders({
          Authorization: 'Bearer ' + token
        });
      } catch (error) {
        throw error;
      }
    }
  }, {
    key: "testServerIsAvailable",
    value: function () {
      var _testServerIsAvailable = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return this.authentication.createToken();
            case 1:
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              if (!(_t.status === 405 || _t.status === undefined)) {
                _context.next = 3;
                break;
              }
              throw _t;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function testServerIsAvailable() {
        return _testServerIsAvailable.apply(this, arguments);
      }
      return testServerIsAvailable;
    }()
  }, {
    key: "signInWithPasswordAndEmail",
    value: function () {
      var _signInWithPasswordAndEmail = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
        var email, password, auth, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              email = _ref2.email, password = _ref2.password;
              _context2.prev = 1;
              if ((0, _validations.validateEmailAddress)(email)) {
                _context2.next = 2;
                break;
              }
              throw new Error(_content["default"].forms.emailInvalidCharacters);
            case 2:
              this.setupHeaderBasicAuth({
                username: email,
                password: password
              });
              _context2.next = 3;
              return this.storeBasicAuthInformation({
                username: email,
                password: password
              });
            case 3:
              _context2.next = 4;
              return this.callApi('authentication', 'createToken');
            case 4:
              auth = _context2.sent;
              _context2.next = 5;
              return this.storeAuthInformation(auth);
            case 5:
              _context2.next = 6;
              return this.cacheAuthInformation(auth, email);
            case 6:
              this.setupHeaderBearerAuth(this.cache.token);
              _context2.next = 7;
              return this.cacheUserAccountInformation(auth.customerId);
            case 7:
              _context2.next = 8;
              return this.cacheUserSettings(auth.userId);
            case 8:
              return _context2.abrupt("return", auth);
            case 9:
              _context2.prev = 9;
              _t2 = _context2["catch"](1);
              throw _t2;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 9]]);
      }));
      function signInWithPasswordAndEmail(_x) {
        return _signInWithPasswordAndEmail.apply(this, arguments);
      }
      return signInWithPasswordAndEmail;
    }()
  }, {
    key: "signInWithUsernameAndPassword",
    value: function () {
      var _signInWithUsernameAndPassword = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
        var username, password, auth, _t3;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              username = _ref3.username, password = _ref3.password;
              _context3.prev = 1;
              this.setupHeaderBasicAuth({
                username: username,
                password: password
              });
              //const auth = await this.authentication.createToken()
              _context3.next = 2;
              return this.callApi('authentication', 'createToken');
            case 2:
              auth = _context3.sent;
              _context3.next = 3;
              return this.storeBasicAuthInformation({
                username: username,
                password: password
              });
            case 3:
              _context3.next = 4;
              return this.storeAuthInformation(auth);
            case 4:
              _context3.next = 5;
              return this.cacheAuthInformation(auth, username);
            case 5:
              this.setupHeaderBearerAuth(this.cache.token);
              _context3.next = 6;
              return this.cacheUserAccountInformation(auth.customerId);
            case 6:
              return _context3.abrupt("return", auth);
            case 7:
              _context3.prev = 7;
              _t3 = _context3["catch"](1);
              throw _t3;
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 7]]);
      }));
      function signInWithUsernameAndPassword(_x2) {
        return _signInWithUsernameAndPassword.apply(this, arguments);
      }
      return signInWithUsernameAndPassword;
    }()
  }, {
    key: "signInWithMobileAndPassword",
    value: function () {
      var _signInWithMobileAndPassword = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref4) {
        var username, password, auth, _t4;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              username = _ref4.username, password = _ref4.password;
              _context4.prev = 1;
              this.setupHeaderBasicAuth({
                username: username,
                password: password
              });
              _context4.next = 2;
              return this.storeBasicAuthInformation({
                username: username,
                password: password
              });
            case 2:
              _context4.next = 3;
              return this.callApi('authentication', 'createToken');
            case 3:
              auth = _context4.sent;
              _context4.next = 4;
              return this.storeAuthInformation(auth);
            case 4:
              _context4.next = 5;
              return this.cacheAuthInformation(auth, username);
            case 5:
              this.setupHeaderBearerAuth(this.cache.token);
              return _context4.abrupt("return", auth);
            case 6:
              _context4.prev = 6;
              _t4 = _context4["catch"](1);
              throw _t4;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 6]]);
      }));
      function signInWithMobileAndPassword(_x3) {
        return _signInWithMobileAndPassword.apply(this, arguments);
      }
      return signInWithMobileAndPassword;
    }()
  }, {
    key: "signInWithAgentUser",
    value: function () {
      var _signInWithAgentUser = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref5) {
        var username, password, auth, _t5;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              username = _ref5.username, password = _ref5.password;
              _context5.prev = 1;
              this.setupHeaderBasicAuth({
                username: username,
                password: password
              });

              //const auth = await this.authentication.createToken()
              _context5.next = 2;
              return this.callApi('authentication', 'createToken');
            case 2:
              auth = _context5.sent;
              _context5.next = 3;
              return this.storeAuthInformation(auth);
            case 3:
              _context5.next = 4;
              return this.cacheAuthInformation(auth, username);
            case 4:
              _context5.next = 5;
              return this.storeBasicAuthInformation({
                username: username,
                password: password
              });
            case 5:
              this.setupHeaderBearerAuth(this.cache.token);

              //Only re-get the catalog if we do not have the catalog information
              if (this.cache.catalogId) {
                _context5.next = 6;
                break;
              }
              _context5.next = 6;
              return this.cacheCatalogInformation();
            case 6:
              return _context5.abrupt("return", auth);
            case 7:
              _context5.prev = 7;
              _t5 = _context5["catch"](1);
              throw _t5;
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 7]]);
      }));
      function signInWithAgentUser(_x4) {
        return _signInWithAgentUser.apply(this, arguments);
      }
      return signInWithAgentUser;
    }()
  }, {
    key: "signInWithVerificationCode",
    value: function () {
      var _signInWithVerificationCode = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref6) {
        var email, code, auth, _t6;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              email = _ref6.email, code = _ref6.code;
              _context6.prev = 1;
              _context6.next = 2;
              return this.setupHeaderBasicAuth({
                username: email,
                password: code
              });
            case 2:
              _context6.next = 3;
              return this.callApi('authentication', 'createToken');
            case 3:
              auth = _context6.sent;
              this.setupHeaderBearerAuth(auth.tokenid || auth.tokenId);
              return _context6.abrupt("return", auth);
            case 4:
              _context6.prev = 4;
              _t6 = _context6["catch"](1);
              throw _t6;
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 4]]);
      }));
      function signInWithVerificationCode(_x5) {
        return _signInWithVerificationCode.apply(this, arguments);
      }
      return signInWithVerificationCode;
    }()
  }, {
    key: "signInWithStoredToken",
    value: function () {
      var _signInWithStoredToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var auth, _t7;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return this.retriveStoredAuthInformation();
            case 1:
              auth = _context7.sent;
              if (!(auth && auth.token)) {
                _context7.next = 5;
                break;
              }
              this.cacheAuthInformation(auth);
              this.setupHeaderBearerAuth(this.cache.token);
              if (!auth.customerId) {
                _context7.next = 4;
                break;
              }
              _context7.next = 2;
              return this.cacheUserAccountInformation(auth.customerId);
            case 2:
              _context7.next = 3;
              return this.cacheUserSettings(auth.userId);
            case 3:
              _context7.next = 5;
              break;
            case 4:
              return _context7.abrupt("return", undefined);
            case 5:
              return _context7.abrupt("return", auth);
            case 6:
              _context7.prev = 6;
              _t7 = _context7["catch"](0);
              throw _t7;
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 6]]);
      }));
      function signInWithStoredToken() {
        return _signInWithStoredToken.apply(this, arguments);
      }
      return signInWithStoredToken;
    }()
  }, {
    key: "signInWithStoredTokenNoSync",
    value: function () {
      var _signInWithStoredTokenNoSync = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var auth, _t8;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return this.retriveStoredAuthInformation();
            case 1:
              auth = _context8.sent;
              if (!(auth && auth.token)) {
                _context8.next = 4;
                break;
              }
              this.cacheAuthInformation(auth);
              this.setupHeaderBearerAuth(this.cache.token);
              if (!auth.customerId) {
                _context8.next = 3;
                break;
              }
              _context8.next = 2;
              return this.cacheUserSettings(auth.userId);
            case 2:
              _context8.next = 4;
              break;
            case 3:
              return _context8.abrupt("return", undefined);
            case 4:
              return _context8.abrupt("return", auth);
            case 5:
              _context8.prev = 5;
              _t8 = _context8["catch"](0);
              throw _t8;
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 5]]);
      }));
      function signInWithStoredTokenNoSync() {
        return _signInWithStoredTokenNoSync.apply(this, arguments);
      }
      return signInWithStoredTokenNoSync;
    }()
  }, {
    key: "refreshToken",
    value: function () {
      var _refreshToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(startTime) {
        var basicAuth, auth;
        return _regenerator["default"].wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return this.retriveStoredBasicAuthInformation();
            case 1:
              basicAuth = _context9.sent;
              if (basicAuth) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              this.setupHeaderStoredBasicAuth(basicAuth);
              _context9.next = 3;
              return this.callApi('authentication', 'createToken', [], startTime);
            case 3:
              auth = _context9.sent;
              _context9.next = 4;
              return this.storeAuthInformation(auth);
            case 4:
              _context9.next = 5;
              return this.cacheAuthInformation(auth);
            case 5:
              this.setupHeaderBearerAuth(this.cache.token);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function refreshToken(_x6) {
        return _refreshToken.apply(this, arguments);
      }
      return refreshToken;
    }()
  }, {
    key: "signOutAndForget",
    value: function () {
      var _signOutAndForget = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
        var _t9;
        return _regenerator["default"].wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              // console.log('cache before clearing: ' + JSON.stringify(this.cache))
              this.clearCache();
              // console.log('cache after clearing: ' + JSON.stringify(this.cache))
              _context0.next = 1;
              return this.deleteStoredAuthInformation();
            case 1:
              _context0.next = 2;
              return this.deleteStoredBasicAuthInformation();
            case 2:
              _context0.next = 4;
              break;
            case 3:
              _context0.prev = 3;
              _t9 = _context0["catch"](0);
              throw _t9;
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[0, 3]]);
      }));
      function signOutAndForget() {
        return _signOutAndForget.apply(this, arguments);
      }
      return signOutAndForget;
    }()
  }, {
    key: "signOutAgent",
    value: function () {
      var _signOutAgent = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1() {
        var _t0;
        return _regenerator["default"].wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              this.unsetCache('agent');
              this.unsetCache('referralCode');
              _context1.next = 2;
              break;
            case 1:
              _context1.prev = 1;
              _t0 = _context1["catch"](0);
              throw _t0;
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[0, 1]]);
      }));
      function signOutAgent() {
        return _signOutAgent.apply(this, arguments);
      }
      return signOutAgent;
    }()
  }, {
    key: "cacheAuthInformation",
    value: function () {
      var _cacheAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(auth, username) {
        var cache, _t1;
        return _regenerator["default"].wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              cache = {};
              if (auth.token || auth.tokenid || auth.tokenId) cache.token = auth.token || auth.tokenid || auth.tokenId;
              if (auth.userId) cache.userId = auth.userId;
              if (auth.customerId) cache.customerId = auth.customerId;
              cache.username = username;
              this.setCache(cache);
              _context10.next = 2;
              break;
            case 1:
              _context10.prev = 1;
              _t1 = _context10["catch"](0);
              throw _t1;
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[0, 1]]);
      }));
      function cacheAuthInformation(_x7, _x8) {
        return _cacheAuthInformation.apply(this, arguments);
      }
      return cacheAuthInformation;
    }()
  }, {
    key: "storeAuthInformation",
    value: function () {
      var _storeAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(auth) {
        var _t10;
        return _regenerator["default"].wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              if (!(auth.token || auth.tokenid || auth.tokenId)) {
                _context11.next = 1;
                break;
              }
              _context11.next = 1;
              return _asyncStorage["default"].setItem('token', "".concat(auth.token || auth.tokenid || auth.tokenId));
            case 1:
              if (!auth.userId) {
                _context11.next = 2;
                break;
              }
              _context11.next = 2;
              return _asyncStorage["default"].setItem('userId', "".concat(auth.userId));
            case 2:
              if (!auth.customerId) {
                _context11.next = 3;
                break;
              }
              _context11.next = 3;
              return _asyncStorage["default"].setItem('customerId', "".concat(auth.customerId));
            case 3:
              if (!auth.employeeId) {
                _context11.next = 4;
                break;
              }
              _context11.next = 4;
              return _asyncStorage["default"].setItem('employeeId', "".concat(auth.employeeId));
            case 4:
              _context11.next = 6;
              break;
            case 5:
              _context11.prev = 5;
              _t10 = _context11["catch"](0);
              throw _t10;
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 5]]);
      }));
      function storeAuthInformation(_x9) {
        return _storeAuthInformation.apply(this, arguments);
      }
      return storeAuthInformation;
    }()
  }, {
    key: "storeBasicAuthInformation",
    value: function () {
      var _storeBasicAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(_ref7) {
        var username, password, credentials, encodedCredentials, _t11;
        return _regenerator["default"].wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              username = _ref7.username, password = _ref7.password;
              _context12.prev = 1;
              if (!(username && password)) {
                _context12.next = 2;
                break;
              }
              credentials = username + ':' + password;
              encodedCredentials = this.encodeCredentials(credentials);
              _context12.next = 2;
              return _asyncStorage["default"].setItem('basicAuthInfo', encodedCredentials);
            case 2:
              _context12.next = 4;
              break;
            case 3:
              _context12.prev = 3;
              _t11 = _context12["catch"](1);
              throw _t11;
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[1, 3]]);
      }));
      function storeBasicAuthInformation(_x0) {
        return _storeBasicAuthInformation.apply(this, arguments);
      }
      return storeBasicAuthInformation;
    }()
  }, {
    key: "retriveStoredAuthInformation",
    value: function () {
      var _retriveStoredAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13(auth) {
        var results, token, userId, customerId, _t12;
        return _regenerator["default"].wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              results = {};
              _context13.next = 1;
              return _asyncStorage["default"].getItem('token');
            case 1:
              token = _context13.sent;
              _context13.next = 2;
              return _asyncStorage["default"].getItem('userId');
            case 2:
              userId = _context13.sent;
              _context13.next = 3;
              return _asyncStorage["default"].getItem('customerId');
            case 3:
              customerId = _context13.sent;
              if (token) results.token = token;
              if (userId) results.userId = userId;
              if (customerId) results.customerId = customerId;
              return _context13.abrupt("return", results);
            case 4:
              _context13.prev = 4;
              _t12 = _context13["catch"](0);
              throw _t12;
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[0, 4]]);
      }));
      function retriveStoredAuthInformation(_x1) {
        return _retriveStoredAuthInformation.apply(this, arguments);
      }
      return retriveStoredAuthInformation;
    }()
  }, {
    key: "retriveStoredBasicAuthInformation",
    value: function () {
      var _retriveStoredBasicAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14() {
        var _t13;
        return _regenerator["default"].wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 1;
              return _asyncStorage["default"].getItem('basicAuthInfo');
            case 1:
              return _context14.abrupt("return", _context14.sent);
            case 2:
              _context14.prev = 2;
              _t13 = _context14["catch"](0);
              throw _t13;
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[0, 2]]);
      }));
      function retriveStoredBasicAuthInformation() {
        return _retriveStoredBasicAuthInformation.apply(this, arguments);
      }
      return retriveStoredBasicAuthInformation;
    }()
  }, {
    key: "deleteStoredAuthInformation",
    value: function () {
      var _deleteStoredAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15() {
        var _t14;
        return _regenerator["default"].wrap(function (_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 1;
              return _asyncStorage["default"].removeItem('token');
            case 1:
              _context15.next = 2;
              return _asyncStorage["default"].removeItem('userId');
            case 2:
              _context15.next = 3;
              return _asyncStorage["default"].removeItem('customerId');
            case 3:
              _context15.next = 4;
              return _asyncStorage["default"].removeItem('employeeId');
            case 4:
              _context15.next = 5;
              return _asyncStorage["default"].removeItem('lastLoginDate');
            case 5:
              _context15.next = 7;
              break;
            case 6:
              _context15.prev = 6;
              _t14 = _context15["catch"](0);
              throw _t14;
            case 7:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 6]]);
      }));
      function deleteStoredAuthInformation() {
        return _deleteStoredAuthInformation.apply(this, arguments);
      }
      return deleteStoredAuthInformation;
    }()
  }, {
    key: "deleteStoredBasicAuthInformation",
    value: function () {
      var _deleteStoredBasicAuthInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16() {
        var _t15;
        return _regenerator["default"].wrap(function (_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 1;
              return _asyncStorage["default"].removeItem('basicAuthInfo');
            case 1:
              _context16.next = 3;
              break;
            case 2:
              _context16.prev = 2;
              _t15 = _context16["catch"](0);
              throw _t15;
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[0, 2]]);
      }));
      function deleteStoredBasicAuthInformation() {
        return _deleteStoredBasicAuthInformation.apply(this, arguments);
      }
      return deleteStoredBasicAuthInformation;
    }()
  }, {
    key: "getAvailableAddons",
    value: function () {
      var _getAvailableAddons = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17(account) {
        var result, addons;
        return _regenerator["default"].wrap(function (_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              result = {};
              _context17.next = 1;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId
              }]);
            case 1:
              addons = _context17.sent;
              result.addons = addons.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              this.setCache(_objectSpread({}, result));
            case 2:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getAvailableAddons(_x10) {
        return _getAvailableAddons.apply(this, arguments);
      }
      return getAvailableAddons;
    }()
  }, {
    key: "getADTAddons",
    value: function () {
      var _getADTAddons = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18() {
        var ADTAddons, _t16;
        return _regenerator["default"].wrap(function (_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 1;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                tags: "ADT"
              }]);
            case 1:
              ADTAddons = _context18.sent;
              ADTAddons = this.filterOutExpiredOffers(ADTAddons);
              ADTAddons.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              this.setCache({
                ADTAddons: ADTAddons
              });
              _context18.next = 3;
              break;
            case 2:
              _context18.prev = 2;
              _t16 = _context18["catch"](0);
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[0, 2]]);
      }));
      function getADTAddons() {
        return _getADTAddons.apply(this, arguments);
      }
      return getADTAddons;
    }()
  }, {
    key: "cacheUserAccountInformation",
    value: function () {
      var _cacheUserAccountInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19(customerId) {
        var accountId, billingMode, serviceId, serviceLegacyId, accounts, accountResponse, customer, account, i, _account, services, service, prepaidService, catalogs, catalog, catalogId, _t17, _t18, _t19;
        return _regenerator["default"].wrap(function (_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              accountId = undefined;
              billingMode = undefined;
              serviceId = undefined;
              serviceLegacyId = undefined;
              accounts = [];
              console.log('in cacheUserAccountInformation with customerId: ' + customerId);
              // Account
              //const accountResponse = await this.customer.getAccounts(customerId)
              console.log('getting accountResponse');
              _context19.next = 1;
              return this.callApi('customer', 'getAccounts', [customerId]);
            case 1:
              accountResponse = _context19.sent;
              console.log('accountResponse is ' + JSON.stringify(accountResponse, null, 2));
              _context19.next = 2;
              return this.callApi('customer', 'getCustomer', [this.cache.customerId]);
            case 2:
              customer = _context19.sent;
              if (!(accountResponse && accountResponse.length > 0)) {
                _context19.next = 8;
                break;
              }
              account = accountResponse[0];
              accountId = account.accountId;
              billingMode = account.billingMode;

              // do the sort so that the mobile accounts are returned first
              accountResponse.sort(function (a, b) {
                return a.accountType < b.accountType ? 1 : -1;
              });

              // Service
              //const servicesResponse = await this.account.getServices(accountId)
              _t17 = _regenerator["default"].keys(accountResponse);
            case 3:
              if ((_t18 = _t17()).done) {
                _context19.next = 8;
                break;
              }
              i = _t18.value;
              _account = accountResponse[i];
              _context19.next = 4;
              return this.callApi('account', 'getServices', [_account.accountId]);
            case 4:
              services = _context19.sent;
              console.log('service response in cacheUserAccountInformation: ' + JSON.stringify(services, null, 2));
              if (!(services && services.length > 0)) {
                _context19.next = 6;
                break;
              }
              service = services[0];
              _account.services = services;
              accounts.push(_account);
              if (!((service === null || service === void 0 ? void 0 : service.status) === 'Disconnected')) {
                _context19.next = 5;
                break;
              }
              throw {
                message: _content["default"].errors.serviceDisconnected,
                status: 500
              };
            case 5:
              //At the moment this will just use the very last service
              //TODO - we should improve this throughout the front ends
              serviceId = service === null || service === void 0 ? void 0 : service.serviceId;
              serviceLegacyId = service === null || service === void 0 ? void 0 : service.serviceLegacyId;
              _context19.next = 7;
              break;
            case 6:
              //temporary hack, if no services come back then create a shadow one to allow for service-free registration and activation
              prepaidService = {
                serviceId: 0,
                serviceLegacyId: 'NOSERVICE',
                billingMode: 'Prepaid',
                accountNumber: _account.accountId,
                lineIdentifier: '-',
                serviceType: 'Mobile',
                status: 'awaiting-activation'
              };
              _account.services = [prepaidService];
              accounts.push(_account);
            case 7:
              _context19.next = 3;
              break;
            case 8:
              if (this.cache.catalogId) {
                _context19.next = 10;
                break;
              }
              _context19.next = 9;
              return this.callApi('catalog', 'getCatalogs', [{
                operatorCode: this.configuration.catalogName
              }]);
            case 9:
              catalogs = _context19.sent;
              catalog = catalogs[0];
              catalogId = catalog.catalogId;
              this.setCache({
                catalogId: catalogId
              });
            case 10:
              this.setCache({
                accountId: accountId,
                billingMode: billingMode,
                serviceId: serviceId,
                serviceLegacyId: serviceLegacyId,
                accounts: accounts
              });
              _context19.next = 12;
              break;
            case 11:
              _context19.prev = 11;
              _t19 = _context19["catch"](0);
              throw _t19;
            case 12:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this, [[0, 11]]);
      }));
      function cacheUserAccountInformation(_x11) {
        return _cacheUserAccountInformation.apply(this, arguments);
      }
      return cacheUserAccountInformation;
    }()
  }, {
    key: "cacheUserInformation",
    value: function () {
      var _cacheUserInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20(customerId, filter) {
        var options, accountResponse, customer, account, accountId, billingMode, accounts, services, i, _account2, loadAccount, j, accountToLoad, servicesResponse, prepaidService, catalogs, catalog, catalogId, _t20, _t21, _t22;
        return _regenerator["default"].wrap(function (_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              // Account
              //const accountResponse = await this.customer.getAccounts(customerId)
              options = {};
              options.accountType = filter;
              _context20.next = 1;
              return this.callApi('customer', 'getAccounts', [customerId, options]);
            case 1:
              accountResponse = _context20.sent;
              _context20.next = 2;
              return this.callApi('customer', 'getCustomer', [this.cache.customerId]);
            case 2:
              customer = _context20.sent;
              console.log('Customer response: ', JSON.stringify(customer, null, 2));

              //SB - When dealing with mobile services we are only interested in prepaid accounts at the moment
              if (filter === 'Mobile') {
                accountResponse = accountResponse.filter(function (acc) {
                  return acc.billingMode === 'Prepaid';
                });
              }
              account = accountResponse[0];
              accountId = account !== undefined ? account.accountId : '';
              billingMode = account !== undefined ? account.billingMode : '';
              accounts = this.cache.accounts !== undefined ? this.cache.accounts : [];
              services = this.cache.services !== undefined ? this.cache.services : []; // do the sort so that the mobile accounts are returned first
              accountResponse.sort(function (a, b) {
                return a.accountId < b.accountId ? 1 : -1;
              });

              // Service
              if (!(accountResponse.length > 0)) {
                _context20.next = 7;
                break;
              }
              _t20 = _regenerator["default"].keys(accountResponse);
            case 3:
              if ((_t21 = _t20()).done) {
                _context20.next = 6;
                break;
              }
              i = _t21.value;
              _account2 = accountResponse[i];
              loadAccount = true;
              for (j in accounts) {
                if (_account2.primaryIdentifier === accounts[j].primaryIdentifier) {
                  loadAccount = false;
                }
              }
              if (!loadAccount) {
                _context20.next = 5;
                break;
              }
              accountToLoad = accountResponse[i];
              console.log('Loading account: ', accountToLoad);
              _context20.next = 4;
              return this.callApi('account', 'getServices', [accountToLoad.accountId]);
            case 4:
              servicesResponse = _context20.sent;
              console.log('Services response: ', JSON.stringify(servicesResponse, null, 2));
              _account2.services = servicesResponse;
              accounts.push(_account2);
              servicesResponse.map(function (service) {
                if (service.billingMode === 'PREPAID') {
                  console.log('pushing a prepaid service: ', JSON.stringify(service, null, 2));
                  services.push(service);
                }
              });
            case 5:
              _context20.next = 3;
              break;
            case 6:
              //at the very end of this, if we have an account but no services we need to create a shadow PREPAID service
              if (services.length === 0) {
                console.log('Creating a shadow prepaid service for account: ', JSON.stringify(account, null, 2));
                prepaidService = {
                  serviceId: 0,
                  serviceLegacyId: 'NOSERVICE',
                  billingMode: 'Prepaid',
                  accountNumber: account.accountId,
                  lineIdentifier: '-',
                  serviceType: 'Mobile',
                  status: 'awaiting-activation'
                };
                services.push(prepaidService);
                //also set the shadow service on the first account (this is ugly, but is to allow for service-free registration)
                accounts[0].services = [prepaidService];
              }
            case 7:
              _context20.next = 8;
              return this.callApi('catalog', 'getCatalogs', [{
                operatorCode: this.configuration.catalogName
              }]);
            case 8:
              catalogs = _context20.sent;
              catalog = catalogs[0];
              catalogId = catalog.catalogId;
              this.setCache({
                accountId: accountId,
                billingMode: billingMode,
                catalogId: catalogId,
                accounts: accounts,
                services: services
              });
              _context20.next = 10;
              break;
            case 9:
              _context20.prev = 9;
              _t22 = _context20["catch"](0);
              throw _t22;
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this, [[0, 9]]);
      }));
      function cacheUserInformation(_x12, _x13) {
        return _cacheUserInformation.apply(this, arguments);
      }
      return cacheUserInformation;
    }()
  }, {
    key: "cacheUserSettings",
    value: function () {
      var _cacheUserSettings = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee21(userId) {
        var user, language, username, _t23;
        return _regenerator["default"].wrap(function (_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              _context21.next = 1;
              return this.callApi('user', 'getUser', [userId]);
            case 1:
              user = _context21.sent;
              //currently just storing language, but may do more in future
              if (user.language) {
                language = user.language;
                this.setCache({
                  language: language
                });
              }
              if (user.userName) {
                username = user.userName;
                this.setCache({
                  username: username
                });
              }
              _context21.next = 3;
              break;
            case 2:
              _context21.prev = 2;
              _t23 = _context21["catch"](0);
              throw _t23;
            case 3:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this, [[0, 2]]);
      }));
      function cacheUserSettings(_x14) {
        return _cacheUserSettings.apply(this, arguments);
      }
      return cacheUserSettings;
    }()
  }, {
    key: "updateLanguage",
    value: function () {
      var _updateLanguage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee22(userId, language) {
        return _regenerator["default"].wrap(function (_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              this.setCache({
                language: language
              });
              //important that we do NOT await here, we want this call to be async
              this.updateLanguageOnServer(userId, language);
            case 1:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function updateLanguage(_x15, _x16) {
        return _updateLanguage.apply(this, arguments);
      }
      return updateLanguage;
    }()
  }, {
    key: "updateLanguageInCache",
    value: function () {
      var _updateLanguageInCache = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee23(language) {
        return _regenerator["default"].wrap(function (_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              this.setCache({
                language: language
              });
            case 1:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function updateLanguageInCache(_x17) {
        return _updateLanguageInCache.apply(this, arguments);
      }
      return updateLanguageInCache;
    }()
  }, {
    key: "updateLanguageOnServer",
    value: function () {
      var _updateLanguageOnServer = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee24(userId, language) {
        var user, _t24;
        return _regenerator["default"].wrap(function (_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              _context24.next = 1;
              return this.callApi('user', 'getUser', [userId]);
            case 1:
              user = _context24.sent;
              user.language = language;
              _context24.next = 2;
              return this.callApi('user', 'modifyUser', [userId, user]);
            case 2:
              this.setCache({
                language: language
              });
              _context24.next = 4;
              break;
            case 3:
              _context24.prev = 3;
              _t24 = _context24["catch"](0);
              throw _t24;
            case 4:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this, [[0, 3]]);
      }));
      function updateLanguageOnServer(_x18, _x19) {
        return _updateLanguageOnServer.apply(this, arguments);
      }
      return updateLanguageOnServer;
    }()
  }, {
    key: "cacheCatalogInformation",
    value: function () {
      var _cacheCatalogInformation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee25() {
        var catalogs, catalog, catalogId, _t25;
        return _regenerator["default"].wrap(function (_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              _context25.next = 1;
              return this.callApi('catalog', 'getCatalogs', [{
                operatorCode: this.configuration.catalogName
              }]);
            case 1:
              catalogs = _context25.sent;
              catalog = catalogs[0];
              catalogId = catalog.catalogId;
              this.setCache({
                catalogId: catalogId
              });
              _context25.next = 3;
              break;
            case 2:
              _context25.prev = 2;
              _t25 = _context25["catch"](0);
              throw _t25;
            case 3:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this, [[0, 2]]);
      }));
      function cacheCatalogInformation() {
        return _cacheCatalogInformation.apply(this, arguments);
      }
      return cacheCatalogInformation;
    }()
  }, {
    key: "sortProducts",
    value: function sortProducts(productArray) {
      productArray.sort(function (productA, productB) {
        return productA.rank - productB.rank;
      });
      return productArray;
    }
  }, {
    key: "getProvisionedProducts",
    value: function () {
      var _getProvisionedProducts = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee26(account, service) {
        var planProducts, toReturn, productInstances;
        return _regenerator["default"].wrap(function (_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 1;
              return this.callApi('service', 'getServicePlanProductInstances', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId]);
            case 1:
              planProducts = _context26.sent;
              toReturn = {
                planProduct: planProducts[0]
              }; //toReturn.planProduct = planProducts[0]
              _context26.next = 2;
              return this.callApi('service', 'getServiceAddOnProductInstances', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId]);
            case 2:
              productInstances = _context26.sent;
              //arrange the product instances in rank order so the primary add-on for prepaid is first
              toReturn.productInstances = productInstances.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              return _context26.abrupt("return", toReturn);
            case 3:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function getProvisionedProducts(_x20, _x21) {
        return _getProvisionedProducts.apply(this, arguments);
      }
      return getProvisionedProducts;
    }()
  }, {
    key: "getMediaProducts",
    value: function () {
      var _getMediaProducts = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee27(account, service) {
        var mediaSubscriptions, toReturn, mediaPPVs;
        return _regenerator["default"].wrap(function (_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 1;
              return this.callApi('service', 'getServiceMediaSubscriptionProductInstances', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId]);
            case 1:
              mediaSubscriptions = _context27.sent;
              toReturn = {
                mediaSubscriptions: mediaSubscriptions
              }; //toReturn.planProduct = planProducts[0]
              _context27.next = 2;
              return this.callApi('service', 'getServiceMediaPayPerViewProductInstances', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId]);
            case 2:
              mediaPPVs = _context27.sent;
              //arrange the product instances in rank order so the primary add-on for prepaid is first
              toReturn.mediaPPVs = mediaPPVs.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              return _context27.abrupt("return", toReturn);
            case 3:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function getMediaProducts(_x22, _x23) {
        return _getMediaProducts.apply(this, arguments);
      }
      return getMediaProducts;
    }()
  }, {
    key: "getAccountBalances",
    value: function () {
      var _getAccountBalances = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee28(account, service) {
        var balances, toReturn, invoicesResponse, latestInvoiceId, latestInvoice;
        return _regenerator["default"].wrap(function (_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 1;
              return this.callApi('service', 'getServiceBalances', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId]);
            case 1:
              balances = _context28.sent;
              toReturn = {
                balances: balances
              };
              if (!(account.billingMode.toUpperCase() === 'POSTPAID')) {
                _context28.next = 4;
                break;
              }
              _context28.next = 2;
              return this.callApi('invoice', 'getServiceInvoices', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId]);
            case 2:
              invoicesResponse = _context28.sent;
              latestInvoiceId = (0, _utils.getLatestInvoiceId)(invoicesResponse);
              if (!latestInvoiceId) {
                _context28.next = 4;
                break;
              }
              _context28.next = 3;
              return this.callApi('invoice', 'getServiceInvoice', [account.accountId, service != undefined ? service.serviceId : account.services[0].serviceId, latestInvoiceId]);
            case 3:
              latestInvoice = _context28.sent;
              toReturn.latestInvoice = latestInvoice;
            case 4:
              return _context28.abrupt("return", toReturn);
            case 5:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function getAccountBalances(_x24, _x25) {
        return _getAccountBalances.apply(this, arguments);
      }
      return getAccountBalances;
    }()
  }, {
    key: "getProvisionedProductsForService",
    value: function () {
      var _getProvisionedProductsForService = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee29(account, service) {
        var planProducts, toReturn, provisionedAddOns, _getCategorisedAddOns, provisionedOneOffAddOns, provisionedRecurringAddOns;
        return _regenerator["default"].wrap(function (_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 1;
              return this.callApi('service', 'getServicePlanProductInstances', [account.accountId, service.serviceId]);
            case 1:
              planProducts = _context29.sent;
              toReturn = {
                planProduct: planProducts[0]
              }; //toReturn.planProduct = planProducts[0]
              _context29.next = 2;
              return this.callApi('service', 'getServiceAddOnProductInstances', [account.accountId, service.serviceId]);
            case 2:
              provisionedAddOns = _context29.sent;
              _getCategorisedAddOns = (0, _utils.getCategorisedAddOns)(provisionedAddOns), provisionedOneOffAddOns = _getCategorisedAddOns.oneoff, provisionedRecurringAddOns = _getCategorisedAddOns.recurring;
              toReturn.provisionedOneOffAddOns = provisionedOneOffAddOns.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              toReturn.provisionedRecurringAddOns = provisionedRecurringAddOns;
              return _context29.abrupt("return", toReturn);
            case 3:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function getProvisionedProductsForService(_x26, _x27) {
        return _getProvisionedProductsForService.apply(this, arguments);
      }
      return getProvisionedProductsForService;
    }()
  }, {
    key: "getAccountBalancesForService",
    value: function () {
      var _getAccountBalancesForService = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee30(account, service) {
        var balances, toReturn, invoicesResponse, latestInvoiceId, latestInvoice;
        return _regenerator["default"].wrap(function (_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 1;
              return this.callApi('service', 'getServiceBalances', [account.accountId, service.serviceId]);
            case 1:
              balances = _context30.sent;
              toReturn = {
                balances: balances
              };
              if (!(account.billingMode.toUpperCase() === 'POSTPAID')) {
                _context30.next = 4;
                break;
              }
              _context30.next = 2;
              return this.callApi('invoice', 'getServiceInvoices', [account.accountId, service.serviceId]);
            case 2:
              invoicesResponse = _context30.sent;
              latestInvoiceId = (0, _utils.getLatestInvoiceId)(invoicesResponse);
              if (!latestInvoiceId) {
                _context30.next = 4;
                break;
              }
              _context30.next = 3;
              return this.callApi('invoice', 'getServiceInvoice', [account.accountId, service.serviceId, latestInvoiceId]);
            case 3:
              latestInvoice = _context30.sent;
              toReturn.latestInvoice = latestInvoice;
            case 4:
              return _context30.abrupt("return", toReturn);
            case 5:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function getAccountBalancesForService(_x28, _x29) {
        return _getAccountBalancesForService.apply(this, arguments);
      }
      return getAccountBalancesForService;
    }()
  }, {
    key: "filterOutExpiredOffers",
    value: function filterOutExpiredOffers(products) {
      if (products) {
        return products.filter(function (product) {
          return product.saleExpiryDate >= new Date();
        });
      }
    }
  }, {
    key: "loadBalancesAndInvoices",
    value: function () {
      var _loadBalancesAndInvoices = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee31(account) {
        var result, balancesResponse, balances, invoicesResponse, estimatedInvoice, latestInvoice, provisionedAddOns, _getCategorisedAddOns2, provisionedOneOffAddOns, provisionedRecurringAddOns, oneOffPlans, recurringPlans, recharges, addons, openCashPayments, activeCashPayments, vasOptions, _t26;
        return _regenerator["default"].wrap(function (_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.prev = 0;
              result = {}; // Plan
              // const planResponse = await this.service.getServicePlanProductInstances(
              //   this.cache.accountId,
              //   this.cache.serviceId
              // )
              // const plan = planResponse[0]
              // result.plan = plan
              // Balances
              //const balancesResponse = await this.service.getServiceBalances(this.cache.accountId, this.cache.serviceId)
              console.log('before getting service balances cache is: ' + JSON.stringify(this.cache, null, 2));
              _context31.next = 1;
              return this.callApi('service', 'getServiceBalances', [account.accountId, account.services[0].serviceId]);
            case 1:
              balancesResponse = _context31.sent;
              console.log('balances response is: ' + JSON.stringify(balancesResponse, null, 2));
              balances = (0, _utils.getFilteredBalances)(balancesResponse);
              if (Object.values(balances).length > 0) {
                if (balances && balances.dataBreakdown && balances.dataBreakdown.map(function (balance) {
                  if (!balance.quantity) {
                    balance.quantity = 0;
                  }
                })) if (balances && balances.textBreakdown && balances.textBreakdown.map(function (balance) {
                  if (!balance.quantity) {
                    balance.quantity = 0;
                  }
                })) if (balances && balances.voiceBreakdown && balances.voiceBreakdown.map(function (balance) {
                  if (!balance.quantity) {
                    balance.quantity = 0;
                  }
                })) result.balances = balances;
              }
              if (!this.isPostpaid) {
                _context31.next = 4;
                break;
              }
              _context31.next = 2;
              return this.callApi('invoice', 'getServiceInvoices', [account.accountId, account.services[0].serviceId]);
            case 2:
              invoicesResponse = _context31.sent;
              // set bill estimation
              estimatedInvoice = invoicesResponse.find(function (invoice) {
                return invoice.category === 'ESTIMATED';
              });
              result.estimatedInvoice = estimatedInvoice;

              // user might not have a bill ready
              // const latestInvoiceId = getLatestInvoiceId(invoicesResponse)
              this.cache.latestInvoiceId = (0, _utils.getLatestInvoiceId)(invoicesResponse);
              if (!this.cache.latestInvoiceId) {
                _context31.next = 4;
                break;
              }
              _context31.next = 3;
              return this.callApi('invoice', 'getServiceInvoice', [account.accountId, account.services[0].serviceId, this.cache.latestInvoiceId]);
            case 3:
              latestInvoice = _context31.sent;
              result.latestInvoice = latestInvoice;
            case 4:
              _context31.next = 5;
              return this.callApi('service', 'getServiceAddOnProductInstances', [account.accountId, account.services[0].serviceId]);
            case 5:
              provisionedAddOns = _context31.sent;
              console.log('[CLIENT] - Provisioned Add-Ons: ', JSON.stringify(provisionedAddOns, null, 2));
              _getCategorisedAddOns2 = (0, _utils.getCategorisedAddOns)(provisionedAddOns), provisionedOneOffAddOns = _getCategorisedAddOns2.oneoff, provisionedRecurringAddOns = _getCategorisedAddOns2.recurring;
              console.log('[CLIENT] - after filtering, provisionedRecurringAddOns: ', JSON.stringify(provisionedRecurringAddOns, null, 2));
              console.log('[CLIENT] - after filtering, provisionedOneOffAddOns: ', JSON.stringify(provisionedOneOffAddOns, null, 2));
              result.provisionedOneOffAddOns = provisionedOneOffAddOns.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              result.provisionedRecurringAddOns = provisionedRecurringAddOns;
              console.log('result after setting add ons is: ', JSON.stringify(result, null, 2));

              /*const oneOffPlans = await this.catalog.getAddOnsProducts(this.cache.catalogId, {
                tags: "package,oneoff"
              }) */
              _context31.next = 6;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "package,oneoff"
              }]);
            case 6:
              oneOffPlans = _context31.sent;
              result.oneOffPlans = oneOffPlans.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              /*const recurringPlans =  await this.catalog.getAddOnsProducts(this.cache.catalogId, {
                tags: "package,recurring"
              }) */
              _context31.next = 7;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "package,recurring"
              }]);
            case 7:
              recurringPlans = _context31.sent;
              result.recurringPlans = recurringPlans.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              //const recharges = await this.catalog.getRechargesProducts(this.cache.catalogId)
              _context31.next = 8;
              return this.callApi('catalog', 'getRechargesProducts', [this.cache.catalogId]);
            case 8:
              recharges = _context31.sent;
              result.recharges = recharges.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              /*const addons = await this.catalog.getAddOnsProducts(this.cache.catalogId, {
                accountId: this.cache.accountId,
                serviceId: this.cache.serviceId,
                tags: "bolton,oneoff"
              })*/
              console.log('[CLIENT] - Getting Add-Ons for accountId: ', account.accountId, ' serviceId: ', account.services[0].serviceId);
              _context31.next = 9;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "bolt-on"
              }]);
            case 9:
              addons = _context31.sent;
              console.log('[CLIENT] - Available Add-Ons: ', JSON.stringify(addons, null, 2));
              result.addons = addons.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              //const openCashPayments = await this.confirmedBasket.getConfirmedBaskets(this.cache.userId, {status: "awaiting-cash-payment"})
              _context31.next = 10;
              return this.callApi('confirmedBasket', 'getConfirmedBaskets', [this.cache.userId, {
                status: "awaiting-cash-payment"
              }]);
            case 10:
              openCashPayments = _context31.sent;
              activeCashPayments = [];
              if (openCashPayments.length) {
                activeCashPayments = openCashPayments.filter(function (confirmedBasket) {
                  var paymentExpiryDate = new Date(confirmedBasket.creationDate);
                  paymentExpiryDate.setDate(paymentExpiryDate.getDate() + 1);
                  return paymentExpiryDate >= new Date();
                });
              }
              if (activeCashPayments) {
                activeCashPayments.sort(function (confirmedBasketA, confirmedBasketB) {
                  return confirmedBasketB.creationDate - confirmedBasketA.creationDate;
                });
              }
              result.openCashPayments = activeCashPayments;

              //const vasOptions = await this.catalog.getBooleanValueAddedServicesProducts(this.cache.catalogId)
              _context31.next = 11;
              return this.callApi('catalog', 'getBooleanValueAddedServicesProducts', [this.cache.catalogId]);
            case 11:
              vasOptions = _context31.sent;
              vasOptions = this.filterOutExpiredOffers(vasOptions);
              result.vasOptions = vasOptions;
              this.setCache(_objectSpread({
                loading: false
              }, result));
              console.log('loadBalancesAndInvoices after setting cache, cache is: ' + JSON.stringify(this.cache, null, 2));
              return _context31.abrupt("return", result);
            case 12:
              _context31.prev = 12;
              _t26 = _context31["catch"](0);
              throw _t26;
            case 13:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this, [[0, 12]]);
      }));
      function loadBalancesAndInvoices(_x30) {
        return _loadBalancesAndInvoices.apply(this, arguments);
      }
      return loadBalancesAndInvoices;
    }()
  }, {
    key: "loadBalancesAndInvoicesPostpaid",
    value: function () {
      var _loadBalancesAndInvoicesPostpaid = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee32(account) {
        var result, balancesResponse, balances, invoicesResponse, estimatedInvoice, latestInvoice, provisionedAddOns, _getCategorisedAddOns3, provisionedOneOffAddOns, provisionedRecurringAddOns, oneOffPlans, recurringPlans, recharges, addons, recurringAddons, i, openCashPayments, activeCashPayments, vasOptions, _t27;
        return _regenerator["default"].wrap(function (_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;
              result = {}; // Plan
              // const planResponse = await this.service.getServicePlanProductInstances(
              //   this.cache.accountId,
              //   this.cache.serviceId
              // )
              // const plan = planResponse[0]
              // result.plan = plan
              // Balances
              //const balancesResponse = await this.service.getServiceBalances(this.cache.accountId, this.cache.serviceId)
              _context32.next = 1;
              return this.callApi('service', 'getServiceBalances', [account.accountId, account.services[0].serviceId]);
            case 1:
              balancesResponse = _context32.sent;
              balances = (0, _utils.getFilteredBalances)(balancesResponse);
              if (Object.values(balances).length > 0) {
                if (balances && balances.dataBreakdown && balances.dataBreakdown.map(function (balance) {
                  if (!balance.quantity) {
                    balance.quantity = 0;
                  }
                })) if (balances && balances.textBreakdown && balances.textBreakdown.map(function (balance) {
                  if (!balance.quantity) {
                    balance.quantity = 0;
                  }
                })) if (balances && balances.voiceBreakdown && balances.voiceBreakdown.map(function (balance) {
                  if (!balance.quantity) {
                    balance.quantity = 0;
                  }
                })) result.postpaidBalances = balances;
              }
              if (!(account.billingMode.toUpperCase() === 'POSTPAID')) {
                _context32.next = 4;
                break;
              }
              _context32.next = 2;
              return this.callApi('invoice', 'getServiceInvoices', [account.accountId, account.services[0].serviceId]);
            case 2:
              invoicesResponse = _context32.sent;
              // set bill estimation
              estimatedInvoice = invoicesResponse.find(function (invoice) {
                return invoice.category === 'ESTIMATED';
              });
              result.postpaidEstimatedInvoice = estimatedInvoice;

              // user might not have a bill ready
              // const latestInvoiceId = getLatestInvoiceId(invoicesResponse)
              this.cache.latestInvoiceId = (0, _utils.getLatestInvoiceId)(invoicesResponse);
              if (!this.cache.latestInvoiceId) {
                _context32.next = 4;
                break;
              }
              _context32.next = 3;
              return this.callApi('invoice', 'getServiceInvoice', [account.accountId, account.services[0].serviceId, this.cache.latestInvoiceId]);
            case 3:
              latestInvoice = _context32.sent;
              result.postpaidLatestInvoice = latestInvoice;
            case 4:
              _context32.next = 5;
              return this.callApi('service', 'getServiceAddOnProductInstances', [account.accountId, account.services[0].serviceId]);
            case 5:
              provisionedAddOns = _context32.sent;
              _getCategorisedAddOns3 = (0, _utils.getCategorisedAddOns)(provisionedAddOns), provisionedOneOffAddOns = _getCategorisedAddOns3.oneoff, provisionedRecurringAddOns = _getCategorisedAddOns3.recurring;
              result.postpaidProvisionedOneOffAddOns = provisionedOneOffAddOns.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });
              result.postpaidProvisionedRecurringAddOns = provisionedRecurringAddOns;

              /*const oneOffPlans = await this.catalog.getAddOnsProducts(this.cache.catalogId, {
                tags: "package,oneoff"
              }) */
              _context32.next = 6;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "package,oneoff"
              }]);
            case 6:
              oneOffPlans = _context32.sent;
              result.postpaidOneOffPlans = oneOffPlans.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              /*const recurringPlans =  await this.catalog.getAddOnsProducts(this.cache.catalogId, {
                tags: "package,recurring"
              }) */
              _context32.next = 7;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "package,recurring"
              }]);
            case 7:
              recurringPlans = _context32.sent;
              result.postpaidRecurringPlans = recurringPlans.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              //const recharges = await this.catalog.getRechargesProducts(this.cache.catalogId)
              _context32.next = 8;
              return this.callApi('catalog', 'getRechargesProducts', [this.cache.catalogId]);
            case 8:
              recharges = _context32.sent;
              result.postpaidRecharges = recharges.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              /*const addons = await this.catalog.getAddOnsProducts(this.cache.catalogId, {
                accountId: this.cache.accountId,
                serviceId: this.cache.serviceId,
                tags: "bolton,oneoff"
              })*/
              _context32.next = 9;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "bolton,oneoff"
              }]);
            case 9:
              addons = _context32.sent;
              _context32.next = 10;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId, {
                accountId: account.accountId,
                serviceId: account.services[0].serviceId,
                tags: "bolton,recurring"
              }]);
            case 10:
              recurringAddons = _context32.sent;
              if (recurringAddons !== undefined && recurringAddons.length > 0) {
                for (i = 0; i < recurringAddons.length; i++) {
                  addons.push(recurringAddons[i]);
                }
              }
              result.postpaidAddons = addons.slice().sort(function (a, b) {
                return a.rank - b.rank;
              });

              //const openCashPayments = await this.confirmedBasket.getConfirmedBaskets(this.cache.userId, {status: "awaiting-cash-payment"})
              _context32.next = 11;
              return this.callApi('confirmedBasket', 'getConfirmedBaskets', [this.cache.userId, {
                status: "awaiting-cash-payment"
              }]);
            case 11:
              openCashPayments = _context32.sent;
              activeCashPayments = [];
              if (openCashPayments.length) {
                activeCashPayments = openCashPayments.filter(function (confirmedBasket) {
                  var paymentExpiryDate = new Date(confirmedBasket.creationDate);
                  paymentExpiryDate.setDate(paymentExpiryDate.getDate() + 1);
                  return paymentExpiryDate >= new Date();
                });
              }
              if (activeCashPayments) {
                activeCashPayments.sort(function (confirmedBasketA, confirmedBasketB) {
                  return confirmedBasketB.creationDate - confirmedBasketA.creationDate;
                });
              }
              result.postpaidOpenCashPayments = activeCashPayments;

              //const vasOptions = await this.catalog.getBooleanValueAddedServicesProducts(this.cache.catalogId)
              _context32.next = 12;
              return this.callApi('catalog', 'getBooleanValueAddedServicesProducts', [this.cache.catalogId]);
            case 12:
              vasOptions = _context32.sent;
              vasOptions = this.filterOutExpiredOffers(vasOptions);
              result.postpaidVasOptions = vasOptions;
              this.setCache(_objectSpread({
                loading: false
              }, result));
              _context32.next = 14;
              break;
            case 13:
              _context32.prev = 13;
              _t27 = _context32["catch"](0);
              throw _t27;
            case 14:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this, [[0, 13]]);
      }));
      function loadBalancesAndInvoicesPostpaid(_x31) {
        return _loadBalancesAndInvoicesPostpaid.apply(this, arguments);
      }
      return loadBalancesAndInvoicesPostpaid;
    }()
  }, {
    key: "getTransformProducts",
    value: function () {
      var _getTransformProducts = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee33() {
        return _regenerator["default"].wrap(function (_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 1;
              return this.callApi('catalog', 'getBalanceTransformProducts', [this.cache.catalogId]);
            case 1:
              return _context33.abrupt("return", _context33.sent);
            case 2:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function getTransformProducts() {
        return _getTransformProducts.apply(this, arguments);
      }
      return getTransformProducts;
    }()
  }, {
    key: "loadPersonalDetails",
    value: function () {
      var _loadPersonalDetails = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee34() {
        var result, customer, _t28;
        return _regenerator["default"].wrap(function (_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.prev = 0;
              result = {};
              _context34.next = 1;
              return this.callApi('customer', 'getCustomer', [this.cache.customerId]);
            case 1:
              customer = _context34.sent;
              result.customer = customer;
              this.setCache(_objectSpread({}, result));
              _context34.next = 3;
              break;
            case 2:
              _context34.prev = 2;
              _t28 = _context34["catch"](0);
              throw _t28;
            case 3:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this, [[0, 2]]);
      }));
      function loadPersonalDetails() {
        return _loadPersonalDetails.apply(this, arguments);
      }
      return loadPersonalDetails;
    }()
  }, {
    key: "loadPaymentPreference",
    value: function () {
      var _loadPaymentPreference = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee35() {
        var result, paymentPreferences, _t29;
        return _regenerator["default"].wrap(function (_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.prev = 0;
              result = {};
              _context35.next = 1;
              return this.callApi('customer', 'getPaymentPreferences', [this.cache.customerId]);
            case 1:
              paymentPreferences = _context35.sent;
              if (paymentPreferences !== undefined) {
                result.storedPayment = paymentPreferences[0];
              }
              this.setCache(_objectSpread({}, result));
              _context35.next = 3;
              break;
            case 2:
              _context35.prev = 2;
              _t29 = _context35["catch"](0);
              throw _t29;
            case 3:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this, [[0, 2]]);
      }));
      function loadPaymentPreference() {
        return _loadPaymentPreference.apply(this, arguments);
      }
      return loadPaymentPreference;
    }()
  }, {
    key: "createBasket",
    value: function () {
      var _createBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee36() {
        var newBasket, _t30;
        return _regenerator["default"].wrap(function (_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.prev = 0;
              _context36.next = 1;
              return this.callApi('basket', 'createBasket', [this.cache.userId]);
            case 1:
              newBasket = _context36.sent;
              this.setCache({
                currentBasketId: newBasket.basketId,
                basket: newBasket
              });
              return _context36.abrupt("return", newBasket);
            case 2:
              _context36.prev = 2;
              _t30 = _context36["catch"](0);
              throw _t30;
            case 3:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this, [[0, 2]]);
      }));
      function createBasket() {
        return _createBasket.apply(this, arguments);
      }
      return createBasket;
    }()
  }, {
    key: "removeBasket",
    value: function () {
      var _removeBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee37(basketId) {
        var _t31;
        return _regenerator["default"].wrap(function (_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;
              _context37.next = 1;
              return this.callApi('basket', 'removeBasket', [this.cache.userId, basketId]);
            case 1:
              _context37.next = 3;
              break;
            case 2:
              _context37.prev = 2;
              _t31 = _context37["catch"](0);
              throw _t31;
            case 3:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this, [[0, 2]]);
      }));
      function removeBasket(_x32) {
        return _removeBasket.apply(this, arguments);
      }
      return removeBasket;
    }()
  }, {
    key: "addServiceProductToBasket",
    value: function () {
      var _addServiceProductToBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee38(basket, product, extendedData) {
        var extra,
          basketItem,
          updatedBasket,
          _args38 = arguments;
        return _regenerator["default"].wrap(function (_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              extra = _args38.length > 3 && _args38[3] !== undefined ? _args38[3] : {};
              //build up a basket item from the product
              if (product.upfrontCost === null || product.upfrontCost === undefined) {
                product.upfrontCost = 0;
              }
              if (product.upfrontVat === null || product.upfrontVat === undefined) {
                product.upfrontVat = 0;
              }
              console.log('adding this product to basket (pre-itemisation): ' + JSON.stringify(product, null, 2));
              basketItem = this.createBasketItemFromProduct(product, true, true, extendedData, extra);
              basket.serviceItems.push(basketItem);
              //Set the extra fields on the basket
              basket.channel = this.configuration.channelName;
              basket.currency = product.currency;
              basket.customerId = this.cache.customerId;
              basket.message = "Purchasing Product " + product.category;
              basket.subTotal = basket.subTotal != null ? basket.subTotal + product.upfrontCost : product.upfrontCost;
              basket.total = basket.total != null ? basket.total + product.upfrontCost : product.upfrontCost;
              basket.unit = product.costUnit;
              basket.vat = basket.vat != null ? basket.vat + product.upfrontVat : product.upfrontVat;

              //const updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context38.next = 1;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 1:
              updatedBasket = _context38.sent;
              return _context38.abrupt("return", updatedBasket);
            case 2:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function addServiceProductToBasket(_x33, _x34, _x35) {
        return _addServiceProductToBasket.apply(this, arguments);
      }
      return addServiceProductToBasket;
    }()
  }, {
    key: "addAccountProductToBasket",
    value: function () {
      var _addAccountProductToBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee39(basket, product, extendedData) {
        var basketItem, updatedBasket;
        return _regenerator["default"].wrap(function (_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              //build up a basket item from the product
              basketItem = this.createBasketItemFromProduct(product, false, true, extendedData);
              basket.accountItems.push(basketItem);
              //Set the extra fields on the basket
              basket.channel = this.configuration.channelName;
              basket.currency = product.currency;
              basket.customerId = this.cache.customerId;
              basket.message = "Purchasing Product " + product.category;
              basket.subTotal = basket.subTotal != null ? basket.subTotal + product.upfrontCost : 0;
              basket.total = basket.total != null ? basket.total + product.upfrontCost : 0;
              basket.unit = product.costUnit;
              basket.vat += product.upfrontVat;

              //const updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context39.next = 1;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 1:
              updatedBasket = _context39.sent;
              return _context39.abrupt("return", updatedBasket);
            case 2:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this);
      }));
      function addAccountProductToBasket(_x36, _x37, _x38) {
        return _addAccountProductToBasket.apply(this, arguments);
      }
      return addAccountProductToBasket;
    }()
  }, {
    key: "addCustomerProductToBasket",
    value: function () {
      var _addCustomerProductToBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee40(basket, product, extendedData) {
        var basketItem, updatedBasket;
        return _regenerator["default"].wrap(function (_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              //build up a basket item from the product
              basketItem = this.createBasketItemFromProduct(product, false, false, extendedData);
              basket.customerItems.push(basketItem);
              //Set the extra fields on the basket
              basket.channel = this.configuration.channelName;
              basket.currency = product.currency;
              basket.customerId = this.cache.customerId;
              basket.message = "Purchasing Product " + product.category;
              basket.subTotal = basket.subTotal != null ? basket.subTotal + product.upfrontCost : product.upfrontCost;
              basket.total = basket.total != null ? basket.total + product.upfrontCost : product.upfrontCost;
              basket.unit = product.costUnit;
              basket.vat = basket.vat != null ? basket.vat + product.upfrontVat : product.upfrontVat;

              //const updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context40.next = 1;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 1:
              updatedBasket = _context40.sent;
              return _context40.abrupt("return", updatedBasket);
            case 2:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
      function addCustomerProductToBasket(_x39, _x40, _x41) {
        return _addCustomerProductToBasket.apply(this, arguments);
      }
      return addCustomerProductToBasket;
    }()
  }, {
    key: "addExtendedDataToAccountItem",
    value: function () {
      var _addExtendedDataToAccountItem = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee41(basket, productId, extendedData) {
        var item, updatedBasket, _t32;
        return _regenerator["default"].wrap(function (_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.prev = 0;
              item = basket.accountItems.find(function (item) {
                return item.productId === productId;
              });
              if (item) {
                _context41.next = 1;
                break;
              }
              throw new Error('No Item found');
            case 1:
              if (extendedData !== undefined && extendedData !== {}) {
                item.extendedData = JSON.stringify(extendedData);
              }
              //const updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context41.next = 2;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 2:
              updatedBasket = _context41.sent;
              return _context41.abrupt("return", updatedBasket);
            case 3:
              _context41.prev = 3;
              _t32 = _context41["catch"](0);
            case 4:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this, [[0, 3]]);
      }));
      function addExtendedDataToAccountItem(_x42, _x43, _x44) {
        return _addExtendedDataToAccountItem.apply(this, arguments);
      }
      return addExtendedDataToAccountItem;
    }()
  }, {
    key: "addExtendedDataToServiceItem",
    value: function () {
      var _addExtendedDataToServiceItem = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee42(basket, productId, extendedData) {
        var item, _t33;
        return _regenerator["default"].wrap(function (_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.prev = 0;
              item = basket.serviceItems.find(function (item) {
                return item.productId === productId;
              });
              if (item) {
                _context42.next = 1;
                break;
              }
              throw new Error('No Item found');
            case 1:
              if (extendedData !== undefined && extendedData !== null) {
                item.extendedData = JSON.stringify(extendedData);
              }
              return _context42.abrupt("return", basket);
            case 2:
              _context42.prev = 2;
              _t33 = _context42["catch"](0);
            case 3:
            case "end":
              return _context42.stop();
          }
        }, _callee42, null, [[0, 2]]);
      }));
      function addExtendedDataToServiceItem(_x45, _x46, _x47) {
        return _addExtendedDataToServiceItem.apply(this, arguments);
      }
      return addExtendedDataToServiceItem;
    }()
  }, {
    key: "addExtendedDataToServiceDelItem",
    value: function () {
      var _addExtendedDataToServiceDelItem = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee43(basket, productId, extendedData) {
        var item, updatedBasket, _t34;
        return _regenerator["default"].wrap(function (_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.prev = 0;
              item = basket.serviceDelItems.find(function (item) {
                return item.productId === productId;
              });
              if (item) {
                _context43.next = 1;
                break;
              }
              throw new Error('No Item found');
            case 1:
              if (extendedData !== undefined && extendedData !== {}) {
                item.extendedData = JSON.stringify(extendedData);
              }
              //const updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context43.next = 2;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 2:
              updatedBasket = _context43.sent;
              return _context43.abrupt("return", updatedBasket);
            case 3:
              _context43.prev = 3;
              _t34 = _context43["catch"](0);
            case 4:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this, [[0, 3]]);
      }));
      function addExtendedDataToServiceDelItem(_x48, _x49, _x50) {
        return _addExtendedDataToServiceDelItem.apply(this, arguments);
      }
      return addExtendedDataToServiceDelItem;
    }()
  }, {
    key: "createBasketItemFromProduct",
    value: function createBasketItemFromProduct(product, isServiceLevel, isAccountLevel, extendedData) {
      var extra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isAccountLevel ? {
        accountId: this.cache.accountId
      } : {}), {}, {
        catalogId: this.cache.catalogId,
        category: product.category,
        currency: product.currency,
        productId: product.productId
      }, isServiceLevel ? {
        serviceId: this.cache.serviceId
      } : {}), {}, {
        subTotal: product.upfrontCost,
        total: product.upfrontCost,
        unit: product.costUnit,
        vat: product.upfrontVat
      }, extendedData !== undefined && extendedData != {} ? {
        extendedData: JSON.stringify(extendedData)
      } : undefined), extra);
    }
  }, {
    key: "removeServiceProductFromBasket",
    value: function () {
      var _removeServiceProductFromBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee44(basket, product) {
        var i, updatedBasket;
        return _regenerator["default"].wrap(function (_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < basket.serviceItems.length)) {
                _context44.next = 3;
                break;
              }
              if (!(basket.serviceItems[i].productId === product.productId)) {
                _context44.next = 2;
                break;
              }
              basket.serviceItems.splice(i, 1);
              basket.subTotal = basket.subTotal != null ? basket.subTotal - product.subTotal : 0;
              basket.total = basket.total != null ? basket.total - product.total : 0;
              //break out of the for loop so only one product is removed, not multiple
              return _context44.abrupt("continue", 3);
            case 2:
              i++;
              _context44.next = 1;
              break;
            case 3:
              _context44.next = 4;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 4:
              updatedBasket = _context44.sent;
              return _context44.abrupt("return", updatedBasket);
            case 5:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function removeServiceProductFromBasket(_x51, _x52) {
        return _removeServiceProductFromBasket.apply(this, arguments);
      }
      return removeServiceProductFromBasket;
    }()
  }, {
    key: "confirmBasket",
    value: function () {
      var _confirmBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee45(basket) {
        var toBeConfirmed, partialConfirmedBasket, confirmedBasket;
        return _regenerator["default"].wrap(function (_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 1;
              return this.callApi('basket', 'getBasket', [basket.userId, basket.basketId]);
            case 1:
              toBeConfirmed = _context45.sent;
              _context45.next = 2;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, toBeConfirmed]);
            case 2:
              partialConfirmedBasket = _context45.sent;
              _context45.next = 3;
              return this.callApi('confirmedBasket', 'getConfirmedBasket', [partialConfirmedBasket.userId, partialConfirmedBasket.basketId]);
            case 3:
              confirmedBasket = _context45.sent;
              return _context45.abrupt("return", confirmedBasket);
            case 4:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
      function confirmBasket(_x53) {
        return _confirmBasket.apply(this, arguments);
      }
      return confirmBasket;
    }()
  }, {
    key: "payForBasketWithCreditCard",
    value: function () {
      var _payForBasketWithCreditCard = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee46(confirmedBasket, cardDetails) {
        var creditCardPayment, order;
        return _regenerator["default"].wrap(function (_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 1;
              return this.callApi('confirmedBasket', 'createCreditCardPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 1:
              creditCardPayment = _context46.sent;
              creditCardPayment.amount = confirmedBasket.total;
              creditCardPayment.currency = confirmedBasket.currency;
              creditCardPayment.cardDetails = {
                cardNumber: cardDetails.cardNumber,
                cvv: cardDetails.cvv,
                expiryDateMonth: cardDetails.expiryDateMonth,
                expiryDateYear: cardDetails.expiryDateYear,
                nameOnCard: cardDetails.nameOnCard
              };

              //const order = await this.confirmedBasket.modifyCreditCardPaymentMthd(confirmedBasket.userId, confirmedBasket.basketId,
              //                                                                       creditCardPayment.paymentId, creditCardPayment)
              _context46.next = 2;
              return this.callApi('confirmedBasket', 'modifyCreditCardPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId, creditCardPayment.paymentId, creditCardPayment]);
            case 2:
              order = _context46.sent;
              return _context46.abrupt("return", order);
            case 3:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function payForBasketWithCreditCard(_x54, _x55) {
        return _payForBasketWithCreditCard.apply(this, arguments);
      }
      return payForBasketWithCreditCard;
    }()
  }, {
    key: "payForBasketWithInstoreCash",
    value: function () {
      var _payForBasketWithInstoreCash = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee47(confirmedBasket, cashDetails) {
        var instoreCashPayment, order;
        return _regenerator["default"].wrap(function (_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 1;
              return this.callApi('confirmedBasket', 'createInstoreCashPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 1:
              instoreCashPayment = _context47.sent;
              instoreCashPayment.amount = confirmedBasket.total;
              instoreCashPayment.currency = confirmedBasket.currency;
              instoreCashPayment.recieptNumber = cashDetails.recieptNumber;
              _context47.next = 2;
              return this.callApi('confirmedBasket', 'modifyInstoreCashPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId, instoreCashPayment.paymentId, instoreCashPayment]);
            case 2:
              order = _context47.sent;
              return _context47.abrupt("return", order);
            case 3:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this);
      }));
      function payForBasketWithInstoreCash(_x56, _x57) {
        return _payForBasketWithInstoreCash.apply(this, arguments);
      }
      return payForBasketWithInstoreCash;
    }()
  }, {
    key: "payForBasketWithBalance",
    value: function () {
      var _payForBasketWithBalance = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee48(confirmedBasket) {
        var balancePayment, order;
        return _regenerator["default"].wrap(function (_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 1;
              return this.callApi('confirmedBasket', 'createServiceBalanceTransferPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 1:
              balancePayment = _context48.sent;
              balancePayment.amount = confirmedBasket.total;
              balancePayment.currency = confirmedBasket.currency;
              balancePayment.accountId = this.cache.accountId;
              balancePayment.serviceId = this.cache.serviceId;

              //const order = await this.confirmedBasket.modifyServiceBalanceTransferPaymentMthd(confirmedBasket.userId, confirmedBasket.basketId,
              //                                                                       balancePayment.paymentId, balancePayment)
              _context48.next = 2;
              return this.callApi('confirmedBasket', 'modifyServiceBalanceTransferPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId, balancePayment.paymentId, balancePayment]);
            case 2:
              order = _context48.sent;
              return _context48.abrupt("return", order);
            case 3:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function payForBasketWithBalance(_x58) {
        return _payForBasketWithBalance.apply(this, arguments);
      }
      return payForBasketWithBalance;
    }()
  }, {
    key: "payForBasketWithCash",
    value: function () {
      var _payForBasketWithCash = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee49(confirmedBasket) {
        var cashPayment;
        return _regenerator["default"].wrap(function (_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 1;
              return this.callApi('confirmedBasket', 'createOnlineCashPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 1:
              cashPayment = _context49.sent;
              return _context49.abrupt("return", cashPayment);
            case 2:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
      function payForBasketWithCash(_x59) {
        return _payForBasketWithCash.apply(this, arguments);
      }
      return payForBasketWithCash;
    }()
  }, {
    key: "payForBasketWithHostedPayment",
    value: function () {
      var _payForBasketWithHostedPayment = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee50(confirmedBasket, gateway) {
        var hostedPayment, _t35;
        return _regenerator["default"].wrap(function (_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              _context50.prev = 0;
              _context50.next = 1;
              return this.callApi('confirmedBasket', 'createHostedPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId, gateway !== undefined ? {
                gateway: gateway
              } : '']);
            case 1:
              hostedPayment = _context50.sent;
              console.log('hostedPaymentResponse is: ' + JSON.stringify(hostedPayment));
              return _context50.abrupt("return", {
                basketRefId: confirmedBasket.basketRefId,
                gatewayURL: hostedPayment.gatewayURL
              });
            case 2:
              _context50.prev = 2;
              _t35 = _context50["catch"](0);
              throw new Error(_t35.message);
            case 3:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this, [[0, 2]]);
      }));
      function payForBasketWithHostedPayment(_x60, _x61) {
        return _payForBasketWithHostedPayment.apply(this, arguments);
      }
      return payForBasketWithHostedPayment;
    }()
  }, {
    key: "getOrder",
    value: function () {
      var _getOrder = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee51(basketRefId) {
        var orders, _t36;
        return _regenerator["default"].wrap(function (_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _context51.prev = 0;
              _context51.next = 1;
              return this.callApi('orders', 'getOrders', [this.cache.customerId, {
                basketRefId: basketRefId
              }]);
            case 1:
              orders = _context51.sent;
              if (!(orders && orders.length > 0)) {
                _context51.next = 2;
                break;
              }
              return _context51.abrupt("return", orders[0]);
            case 2:
              return _context51.abrupt("return", null);
            case 3:
              _context51.prev = 3;
              _t36 = _context51["catch"](0);
              return _context51.abrupt("return", null);
            case 4:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this, [[0, 3]]);
      }));
      function getOrder(_x62) {
        return _getOrder.apply(this, arguments);
      }
      return getOrder;
    }()
  }, {
    key: "getOrders",
    value: function () {
      var _getOrders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee52(basketRefId) {
        var MAX_RETRIES,
          retry,
          orders,
          finishedOrder,
          _args52 = arguments,
          _t37;
        return _regenerator["default"].wrap(function (_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              MAX_RETRIES = _args52.length > 1 && _args52[1] !== undefined ? _args52[1] : 120;
              _context52.prev = 1;
              retry = 0;
              _context52.next = 2;
              return this.callApi('orders', 'getOrders', [this.cache.customerId, {
                basketRefId: basketRefId
              }]);
            case 2:
              orders = _context52.sent;
              finishedOrder = false;
            case 3:
              if (!(!finishedOrder && retry < MAX_RETRIES)) {
                _context52.next = 6;
                break;
              }
              _context52.next = 4;
              return (0, _delay["default"])(this.orderRefreshTime);
            case 4:
              _context52.next = 5;
              return this.callApi('orders', 'getOrders', [this.cache.customerId, {
                basketRefId: basketRefId
              }]);
            case 5:
              orders = _context52.sent;
              retry++;
              if (orders && orders.length > 0) {
                finishedOrder = orders[0].status === 'successful' || orders[0].status === 'failed' || orders[0].status === 'payment processed';
              }
              _context52.next = 3;
              break;
            case 6:
              if (!(orders && orders.length > 0)) {
                _context52.next = 7;
                break;
              }
              return _context52.abrupt("return", orders[0]);
            case 7:
              return _context52.abrupt("return", null);
            case 8:
              _context52.prev = 8;
              _t37 = _context52["catch"](1);
              if (!(_t37.response && _t37.response.body && (_t37.response.body.messageCode === "SR00043" || _t37.response.body.code === 'DATA_SYNCHRONISING'))) {
                _context52.next = 10;
                break;
              }
              _context52.next = 9;
              return (0, _delay["default"])(this.orderRefreshTime);
            case 9:
              return _context52.abrupt("return", this.getOrders(basketRefId));
            case 10:
              throw _t37;
            case 11:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this, [[1, 8]]);
      }));
      function getOrders(_x63) {
        return _getOrders.apply(this, arguments);
      }
      return getOrders;
    }()
  }, {
    key: "payForBasketWithStoredCard",
    value: function () {
      var _payForBasketWithStoredCard = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee53(confirmedBasket, tokenisedCard) {
        var storedCardPayment, tokenizedCardDetails, order;
        return _regenerator["default"].wrap(function (_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _context53.next = 1;
              return this.callApi('confirmedBasket', 'createTokenizedCardPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 1:
              storedCardPayment = _context53.sent;
              storedCardPayment.gateway = this.configuration.paymentGateway;
              tokenizedCardDetails = {};
              tokenizedCardDetails.cardToken = tokenisedCard.cardToken;
              tokenizedCardDetails.expMonth = tokenisedCard.expMonth;
              tokenizedCardDetails.expYear = tokenisedCard.expYear;
              tokenizedCardDetails.last4Digits = tokenisedCard.last4Digits;
              tokenizedCardDetails.cardType = tokenisedCard.cardType;
              storedCardPayment.tokenizedCardDetails = tokenizedCardDetails;
              _context53.next = 2;
              return this.callApi('confirmedBasket', 'modifyTokenizedCardPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId, storedCardPayment.paymentId, storedCardPayment]);
            case 2:
              order = _context53.sent;
              return _context53.abrupt("return", order);
            case 3:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this);
      }));
      function payForBasketWithStoredCard(_x64, _x65) {
        return _payForBasketWithStoredCard.apply(this, arguments);
      }
      return payForBasketWithStoredCard;
    }()
  }, {
    key: "processConfirmedBasketNoPayment",
    value: function () {
      var _processConfirmedBasketNoPayment = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee54(confirmedBasket) {
        var noPaymentMethod, order;
        return _regenerator["default"].wrap(function (_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 1;
              return this.callApi('confirmedBasket', 'createNoPaymentPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 1:
              noPaymentMethod = _context54.sent;
              _context54.next = 2;
              return this.callApi('confirmedBasket', 'modifyNoPaymentPaymentMthd', [confirmedBasket.userId, confirmedBasket.basketId, noPaymentMethod.paymentId, noPaymentMethod]);
            case 2:
              order = _context54.sent;
              return _context54.abrupt("return", order);
            case 3:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function processConfirmedBasketNoPayment(_x66) {
        return _processConfirmedBasketNoPayment.apply(this, arguments);
      }
      return processConfirmedBasketNoPayment;
    }()
  }, {
    key: "getOrderPollDelay",
    value: function getOrderPollDelay() {
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'standard';
      if (mode !== 'aggressive') {
        return this.orderRefreshTime;
      }
      if (attempt < 3) {
        return 1000;
      }
      if (attempt < 8) {
        return 2000;
      }
      return this.orderRefreshTime;
    }
  }, {
    key: "pollOrderForStatus",
    value: function () {
      var _pollOrderForStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee55(customerId, orderId, startTime) {
        var attempt,
          pollOptions,
          pollMode,
          order,
          timeoutError,
          retryDelay,
          _retryDelay,
          _args55 = arguments,
          _t38;
        return _regenerator["default"].wrap(function (_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              attempt = _args55.length > 3 && _args55[3] !== undefined ? _args55[3] : 0;
              pollOptions = _args55.length > 4 && _args55[4] !== undefined ? _args55[4] : {};
              if (startTime === undefined) {
                startTime = Date.now();
                console.log("[pollOrderForStatus] start orderId=".concat(orderId));
              }
              pollMode = pollOptions.mode || 'standard';
              _context55.prev = 1;
              _context55.next = 2;
              return this.callApi('orders', 'getOrder', [customerId, orderId]);
            case 2:
              order = _context55.sent;
              console.log("[pollOrderForStatus] status=".concat(order.status, " elapsed=").concat(Date.now() - startTime, "ms"));
              if (!(order.status === "successful" || order.status === "awaiting-sim")) {
                _context55.next = 3;
                break;
              }
              return _context55.abrupt("return", order);
            case 3:
              if (!(order.status === "failed")) {
                _context55.next = 4;
                break;
              }
              return _context55.abrupt("return", order);
            case 4:
              if (!(startTime + this.orderRefreshTimeout < Date.now())) {
                _context55.next = 6;
                break;
              }
              // timeout reached
              order.status = _content["default"].errors.timeoutReached;
              if (!(order.status === _content["default"].errors.timeoutReached)) {
                _context55.next = 5;
                break;
              }
              timeoutError = new Error(order.status);
              timeoutError.code = this.timeoutReachedCode;
              throw timeoutError;
            case 5:
              _context55.next = 8;
              break;
            case 6:
              // calling recursively
              retryDelay = this.getOrderPollDelay(attempt, pollMode);
              console.log("[pollOrderForStatus] retrying in ".concat(retryDelay, "ms (attempt ").concat(attempt + 1, ", mode ").concat(pollMode, ")"));
              _context55.next = 7;
              return (0, _delay["default"])(retryDelay);
            case 7:
              return _context55.abrupt("return", this.pollOrderForStatus(customerId, orderId, startTime, attempt + 1, pollOptions));
            case 8:
              _context55.next = 14;
              break;
            case 9:
              _context55.prev = 9;
              _t38 = _context55["catch"](1);
              if (!(_t38.response && _t38.response.body && (_t38.response.body.messageCode === "SR00043" || _t38.response.body.code === 'DATA_SYNCHRONISING'))) {
                _context55.next = 13;
                break;
              }
              // data is still syncronising, try again
              console.log("[pollOrderForStatus] DATA_SYNCHRONISING elapsed=".concat(Date.now() - startTime, "ms"));
              if (!(startTime + this.orderRefreshTimeout < Date.now())) {
                _context55.next = 10;
                break;
              }
              return _context55.abrupt("return", {
                status: _content["default"].errors.timeoutReached,
                code: this.timeoutReachedCode
              });
            case 10:
              // calling recursively
              _retryDelay = this.getOrderPollDelay(attempt, pollMode);
              console.log("[pollOrderForStatus] retrying in ".concat(_retryDelay, "ms (attempt ").concat(attempt + 1, ", mode ").concat(pollMode, ")"));
              _context55.next = 11;
              return (0, _delay["default"])(_retryDelay);
            case 11:
              return _context55.abrupt("return", this.pollOrderForStatus(customerId, orderId, startTime, attempt + 1, pollOptions));
            case 12:
              _context55.next = 14;
              break;
            case 13:
              throw _t38;
            case 14:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this, [[1, 9]]);
      }));
      function pollOrderForStatus(_x67, _x68, _x69) {
        return _pollOrderForStatus.apply(this, arguments);
      }
      return pollOrderForStatus;
    }()
  }, {
    key: "pollGuestOrderForStatus",
    value: function () {
      var _pollGuestOrderForStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee56(orderId) {
        var order;
        return _regenerator["default"].wrap(function (_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 1;
              return this.signInWithAgentUser({
                username: this.configuration.agentUsername,
                password: this.configuration.agentPassword
              });
            case 1:
              _context56.next = 2;
              return this.guestOrders.getOrder(orderId);
            case 2:
              order = _context56.sent;
              if (!(order.status === "successful" || order.status === "failed")) {
                _context56.next = 3;
                break;
              }
              return _context56.abrupt("return", order);
            case 3:
              if (!(order.creationDate + this.configuration.orderRefreshTimeout < Date.now())) {
                _context56.next = 4;
                break;
              }
              // timeout reached
              order.status = _content["default"].general.timeoutReached;
              return _context56.abrupt("return", order);
            case 4:
              _context56.next = 5;
              return (0, _delay["default"])(this.configuration.orderRefreshTime);
            case 5:
              return _context56.abrupt("return", this.pollGuestOrderForStatus(orderId));
            case 6:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
      function pollGuestOrderForStatus(_x70) {
        return _pollGuestOrderForStatus.apply(this, arguments);
      }
      return pollGuestOrderForStatus;
    }()
  }, {
    key: "pollConfirmedBasketForCashPaymentStatus",
    value: function () {
      var _pollConfirmedBasketForCashPaymentStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee57(confirmedBasket, startTime) {
        var toReturn, _t39;
        return _regenerator["default"].wrap(function (_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              if (startTime === undefined) {
                startTime = Date.now();
              }
              _context57.prev = 1;
              _context57.next = 2;
              return this.callApi('confirmedBasket', 'getConfirmedBasket', [confirmedBasket.userId, confirmedBasket.basketId]);
            case 2:
              toReturn = _context57.sent;
              if (!(toReturn.processingStatus === "processed" || toReturn.processingStatus === "awaiting-cash-payment")) {
                _context57.next = 3;
                break;
              }
              return _context57.abrupt("return", toReturn);
            case 3:
              if (!(toReturn.processingStatus === "failed")) {
                _context57.next = 4;
                break;
              }
              return _context57.abrupt("return", toReturn);
            case 4:
              if (!(startTime + this.orderRefreshTimeout < Date.now())) {
                _context57.next = 6;
                break;
              }
              // timeout reached
              toReturn.status = _content["default"].errors.timeoutReached;
              if (!(toReturn.status === _content["default"].errors.timeoutReached)) {
                _context57.next = 5;
                break;
              }
              throw error;
            case 5:
              _context57.next = 8;
              break;
            case 6:
              _context57.next = 7;
              return (0, _delay["default"])(this.orderRefreshTime);
            case 7:
              return _context57.abrupt("return", this.pollConfirmedBasketForCashPaymentStatus(confirmedBasket, startTime));
            case 8:
              _context57.next = 14;
              break;
            case 9:
              _context57.prev = 9;
              _t39 = _context57["catch"](1);
              if (!(_t39.response && _t39.response.body && (_t39.response.body.messageCode === "SR00043" || _t39.response.body.code === 'DATA_SYNCHRONISING'))) {
                _context57.next = 13;
                break;
              }
              if (!(startTime + this.orderRefreshTimeout < Date.now())) {
                _context57.next = 10;
                break;
              }
              return _context57.abrupt("return", {
                status: _content["default"].errors.timeoutReached
              });
            case 10:
              _context57.next = 11;
              return (0, _delay["default"])(this.orderRefreshTime);
            case 11:
              return _context57.abrupt("return", this.pollConfirmedBasketForCashPaymentStatus(confirmedBasket, startTime));
            case 12:
              _context57.next = 14;
              break;
            case 13:
              throw _t39;
            case 14:
            case "end":
              return _context57.stop();
          }
        }, _callee57, this, [[1, 9]]);
      }));
      function pollConfirmedBasketForCashPaymentStatus(_x71, _x72) {
        return _pollConfirmedBasketForCashPaymentStatus.apply(this, arguments);
      }
      return pollConfirmedBasketForCashPaymentStatus;
    }()
  }, {
    key: "getRegionOptions",
    value: function () {
      var _getRegionOptions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee58() {
        var _this = this;
        var _this$cache2, catalogId, selectedPlan, planBillingMode, signUpProducts, signUpProduct, _signUpProduct$option, url, options;
        return _regenerator["default"].wrap(function (_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              _this$cache2 = this.cache, catalogId = _this$cache2.catalogId, selectedPlan = _this$cache2.selectedPlan;
              planBillingMode = selectedPlan.billingMode;
              _context58.next = 1;
              return function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (planBillingMode === prepaidBillingMode) {
                  // return this.catalog.getSignUpPrePaidCustomerProducts(catalogId)
                  return _this.callApi('catalog', 'getSignUpPrePaidCustomerProducts', [catalogId]);
                } else {
                  // return this.catalog.getSignUpPostPaidCustomerProducts(catalogId)
                  return _this.callApi('catalog', 'getSignUpPostPaidCustomerProducts', [catalogId]);
                }
              }();
            case 1:
              signUpProducts = _context58.sent;
              signUpProduct = function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (planBillingMode === prepaidBillingMode) {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === prepaidSignUpLegId;
                  });
                } else {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === postpaidSignUpLegId;
                  });
                }
              }();
              _signUpProduct$option = signUpProduct.options.find(function (item) {
                return item.code === "NUMBER_PREFIXES";
              }), url = _signUpProduct$option.link.href;
              _context58.next = 2;
              return this.retrieveDataFromUrl(url);
            case 2:
              options = _context58.sent;
              return _context58.abrupt("return", options);
            case 3:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
      function getRegionOptions() {
        return _getRegionOptions.apply(this, arguments);
      }
      return getRegionOptions;
    }()
  }, {
    key: "getRegionOptionsWithoutPlan",
    value: function () {
      var _getRegionOptionsWithoutPlan = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee59() {
        var _this2 = this;
        var catalogId, signUpProducts, signUpProduct, _signUpProduct$option2, url, options;
        return _regenerator["default"].wrap(function (_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              catalogId = this.cache.catalogId;
              _context59.next = 1;
              return function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                // if (planBillingMode === prepaidBillingMode){
                // return this.catalog.getSignUpPrePaidCustomerProducts(catalogId)
                return _this2.callApi('catalog', 'getSignUpPrePaidCustomerProducts', [catalogId]);
                // } else {
                //   // return this.catalog.getSignUpPostPaidCustomerProducts(catalogId)
                //   return this.callApi('catalog','getSignUpPostPaidCustomerProducts',[catalogId])
                // }
              }();
            case 1:
              signUpProducts = _context59.sent;
              signUpProduct = function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                // if (planBillingMode === prepaidBillingMode){
                return signUpProducts.find(function (product) {
                  return product.productLegacyId === prepaidSignUpLegId;
                });
                // } else {
                //   return signUpProducts.find((product) => product.productLegacyId === postpaidSignUpLegId)
                // }
              }();
              _signUpProduct$option2 = signUpProduct.options.find(function (item) {
                return item.code === "NUMBER_PREFIXES";
              }), url = _signUpProduct$option2.link.href;
              _context59.next = 2;
              return this.retrieveDataFromUrl(url);
            case 2:
              options = _context59.sent;
              return _context59.abrupt("return", options);
            case 3:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this);
      }));
      function getRegionOptionsWithoutPlan() {
        return _getRegionOptionsWithoutPlan.apply(this, arguments);
      }
      return getRegionOptionsWithoutPlan;
    }()
  }, {
    key: "retrieveDataFromUrl",
    value: function () {
      var _retrieveDataFromUrl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee60(url) {
        var response, _t40;
        return _regenerator["default"].wrap(function (_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.prev = 0;
              _context60.next = 1;
              return _axios["default"].get(url, {
                headers: {
                  Accept: 'application/json',
                  Authorization: "Bearer ".concat(this.cache.token)
                }
              });
            case 1:
              response = _context60.sent;
              return _context60.abrupt("return", response.data);
            case 2:
              _context60.prev = 2;
              _t40 = _context60["catch"](0);
              if (!(_t40.status === 401 && _t40.response !== undefined && _t40.response.body !== undefined && (_t40.response.body.messageCode === 'SR0012' || _t40.response.body.code === 'TOKEN_EXPIRED'))) {
                _context60.next = 4;
                break;
              }
              _context60.next = 3;
              return this.refreshToken();
            case 3:
              return _context60.abrupt("return", this.retrieveDataFromUrl(url));
            case 4:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this, [[0, 2]]);
      }));
      function retrieveDataFromUrl(_x73) {
        return _retrieveDataFromUrl.apply(this, arguments);
      }
      return retrieveDataFromUrl;
    }()
  }, {
    key: "retrieveDataFromUrlWithoutTokenRefresh",
    value: function () {
      var _retrieveDataFromUrlWithoutTokenRefresh = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee61(url) {
        var response;
        return _regenerator["default"].wrap(function (_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              _context61.next = 1;
              return _axios["default"].get(url, {
                headers: {
                  Accept: 'application/json',
                  Authorization: "Bearer ".concat(this.cache.token)
                }
              });
            case 1:
              response = _context61.sent;
              return _context61.abrupt("return", response.data);
            case 2:
            case "end":
              return _context61.stop();
          }
        }, _callee61, this);
      }));
      function retrieveDataFromUrlWithoutTokenRefresh(_x74) {
        return _retrieveDataFromUrlWithoutTokenRefresh.apply(this, arguments);
      }
      return retrieveDataFromUrlWithoutTokenRefresh;
    }()
  }, {
    key: "isSignedIn",
    value: function isSignedIn() {
      try {
        return this.cache.accountId !== undefined && this.cache.serviceId !== undefined && this.cache.token !== undefined;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "createNCABasket",
    value: function () {
      var _createNCABasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee62(selectedPlan) {
        var basket, userId, _t41;
        return _regenerator["default"].wrap(function (_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              if (this.isSignedIn()) {
                _context62.next = 1;
                break;
              }
              _context62.next = 1;
              return this.signInWithUsernameAndPassword({
                username: 'VADSA-GUEST-ROOT',
                password: 'Passw001'
              });
            case 1:
              _context62.prev = 1;
              userId = this.cache.userId; // Create a new basket for the guest user
              _context62.next = 2;
              return this.callApi('basket', 'createBasket', [userId]);
            case 2:
              basket = _context62.sent;
              if (!selectedPlan) {
                _context62.next = 4;
                break;
              }
              _context62.next = 3;
              return this.addServiceProductToBasket(basket, selectedPlan);
            case 3:
              basket = _context62.sent;
            case 4:
              this.setCache({
                cachedBasket: basket
              });
              return _context62.abrupt("return", basket);
            case 5:
              _context62.prev = 5;
              _t41 = _context62["catch"](1);
              throw _t41;
            case 6:
            case "end":
              return _context62.stop();
          }
        }, _callee62, this, [[1, 5]]);
      }));
      function createNCABasket(_x75) {
        return _createNCABasket.apply(this, arguments);
      }
      return createNCABasket;
    }()
  }, {
    key: "addPromoToNCABasket",
    value: function () {
      var _addPromoToNCABasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee63(promoPlans) {
        var basket, _this$cache3, userId, cachedBasket, selectedPlan;
        return _regenerator["default"].wrap(function (_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              _this$cache3 = this.cache, userId = _this$cache3.userId, cachedBasket = _this$cache3.cachedBasket, selectedPlan = _this$cache3.selectedPlan;
              if (this.isSignedIn()) {
                _context63.next = 2;
                break;
              }
              _context63.next = 1;
              return this.signInWithUsernameAndPassword({
                username: 'VADSA-GUEST-ROOT',
                password: 'Passw001'
              });
            case 1:
              _context63.next = 2;
              return createNCABasket(selectedPlan);
            case 2:
              _context63.next = 3;
              return this.callApi('basket', 'getBasket', [userId, cachedBasket.basketId]);
            case 3:
              basket = _context63.sent;
              if (!(promoPlans && promoPlans.length)) {
                _context63.next = 5;
                break;
              }
              _context63.next = 4;
              return this.addPromoPlansToBasket(cachedBasket.basketId, userId, promoPlans);
            case 4:
              basket = _context63.sent;
            case 5:
            case "end":
              return _context63.stop();
          }
        }, _callee63, this);
      }));
      function addPromoToNCABasket(_x76) {
        return _addPromoToNCABasket.apply(this, arguments);
      }
      return addPromoToNCABasket;
    }()
  }, {
    key: "removePromoFromNCABasket",
    value: function () {
      var _removePromoFromNCABasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee64() {
        var basket, _this$cache4, userId, cachedBasket, selectedPlan, i;
        return _regenerator["default"].wrap(function (_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _this$cache4 = this.cache, userId = _this$cache4.userId, cachedBasket = _this$cache4.cachedBasket, selectedPlan = _this$cache4.selectedPlan;
              if (this.isSignedIn()) {
                _context64.next = 2;
                break;
              }
              _context64.next = 1;
              return this.signInWithUsernameAndPassword({
                username: 'VADSA-GUEST-ROOT',
                password: 'Passw001'
              });
            case 1:
              _context64.next = 2;
              return createNCABasket(selectedPlan);
            case 2:
              _context64.next = 3;
              return this.callApi('basket', 'getBasket', [userId, cachedBasket.basketId]);
            case 3:
              basket = _context64.sent;
              for (i = 0; i < basket.serviceItems.length; i++) {
                if (basket.serviceItems[i].productId !== selectedPlan.productId) {
                  this.removeServiceProductFromBasket(basket, basket.serviceItems[i]);
                }
              }
            case 4:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this);
      }));
      function removePromoFromNCABasket() {
        return _removePromoFromNCABasket.apply(this, arguments);
      }
      return removePromoFromNCABasket;
    }()
  }, {
    key: "updateNCABasket",
    value: function () {
      var _updateNCABasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee65() {
        var basket, _this$cache5, userId, catalogId, cachedBasket, selectedPlan, existingSIM, eSIMDispatch, basePlan, extendedDataServLevel, assignSimProducts, assignSimProduct, assignExtendedData, dispatchSimProducts, dispatchSimProduct, dispatchSimExtendedData, _t42;
        return _regenerator["default"].wrap(function (_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _this$cache5 = this.cache, userId = _this$cache5.userId, catalogId = _this$cache5.catalogId, cachedBasket = _this$cache5.cachedBasket, selectedPlan = _this$cache5.selectedPlan, existingSIM = _this$cache5.existingSIM, eSIMDispatch = _this$cache5.eSIMDispatch;
              if (this.isSignedIn()) {
                _context65.next = 2;
                break;
              }
              _context65.next = 1;
              return this.signInWithUsernameAndPassword({
                username: 'VADSA-GUEST-ROOT',
                password: 'Passw001'
              });
            case 1:
              _context65.next = 2;
              return createNCABasket(selectedPlan);
            case 2:
              _context65.prev = 2;
              this.unsetCache('hasSimOrder');

              // retrieve existing basket or create a new basket
              // basket = await this.basket.createBasket(userId)
              _context65.next = 3;
              return this.callApi('basket', 'getBasket', [cachedBasket.userId, cachedBasket.basketId]);
            case 3:
              basket = _context65.sent;
              _context65.next = 4;
              return this.getBasePlan(catalogId);
            case 4:
              basePlan = _context65.sent;
              extendedDataServLevel = {};
              extendedDataServLevel.receiptRequired = false;
              extendedDataServLevel.agentReferalCode = "";
              if (!existingSIM) {
                _context65.next = 7;
                break;
              }
              this.setCache({
                hasSimOrder: true
              });
              _context65.next = 5;
              return this.callApi('catalog', 'getAssignSimProducts', [catalogId]);
            case 5:
              assignSimProducts = _context65.sent;
              assignSimProduct = assignSimProducts.find(function (product) {
                return product.productLegacyId === assignSimLegacyId;
              });
              assignExtendedData = {
                ICCID: existingSIM
              };
              _context65.next = 6;
              return this.addServiceProductToBasket(basket, assignSimProduct, assignExtendedData);
            case 6:
              basket = _context65.sent;
            case 7:
              if (this.cache.referralCode) {
                extendedDataServLevel.agentReferalCode = this.cache.referralCode;
              }

              // add the bundle add on to the basket at the service level
              if (!selectedPlan) {
                _context65.next = 9;
                break;
              }
              _context65.next = 8;
              return this.addExtendedDataToServiceItem(basket, selectedPlan.productId, extendedDataServLevel);
            case 8:
              basket = _context65.sent;
            case 9:
              if (!(basePlan !== undefined || !registerUser)) {
                _context65.next = 11;
                break;
              }
              _context65.next = 10;
              return this.addServiceProductToBasket(basket, basePlan, extendedDataServLevel);
            case 10:
              basket = _context65.sent;
            case 11:
              if (existingSIM) {
                _context65.next = 14;
                break;
              }
              _context65.next = 12;
              return this.callApi('catalog', 'getDispatchSimProducts', [catalogId]);
            case 12:
              dispatchSimProducts = _context65.sent;
              dispatchSimProduct = dispatchSimProducts.find(function (product) {
                return eSIMDispatch ? product.productLegacyId === dispatchESimLegacyId : product.productLegacyId === dispatchSimLegacyId;
              });
              dispatchSimExtendedData = {
                reason: "NewCustomer"
              };
              _context65.next = 13;
              return this.addServiceProductToBasket(basket, dispatchSimProduct, dispatchSimExtendedData);
            case 13:
              basket = _context65.sent;
            case 14:
              _context65.next = 15;
              return this.callApi('basket', 'getBasket', [basket.userId, basket.basketId]);
            case 15:
              basket = _context65.sent;
              return _context65.abrupt("return", {
                basketId: basket.basketId,
                basketUserId: basket.userId
              });
            case 16:
              _context65.prev = 16;
              _t42 = _context65["catch"](2);
              throw _t42;
            case 17:
            case "end":
              return _context65.stop();
          }
        }, _callee65, this, [[2, 16]]);
      }));
      function updateNCABasket() {
        return _updateNCABasket.apply(this, arguments);
      }
      return updateNCABasket;
    }()
  }, {
    key: "addPromoPlansToBasket",
    value: function () {
      var _addPromoPlansToBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee66(basketId, basketUserId, promoPlans) {
        var basket, i, _t43;
        return _regenerator["default"].wrap(function (_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              _context66.prev = 0;
              _context66.next = 1;
              return this.callApi('basket', 'getBasket', [basketUserId, basketId]);
            case 1:
              basket = _context66.sent;
              if (!promoPlans) {
                _context66.next = 5;
                break;
              }
              i = 0;
            case 2:
              if (!(i < promoPlans.length)) {
                _context66.next = 5;
                break;
              }
              _context66.next = 3;
              return this.addServiceProductToBasket(basket, promoPlans[i]);
            case 3:
              basket = _context66.sent;
            case 4:
              i++;
              _context66.next = 2;
              break;
            case 5:
              _context66.next = 6;
              return this.callApi('basket', 'getBasket', [basketUserId, basket.basketId]);
            case 6:
              basket = _context66.sent;
              return _context66.abrupt("return", basket);
            case 7:
              _context66.prev = 7;
              _t43 = _context66["catch"](0);
              throw _t43;
            case 8:
            case "end":
              return _context66.stop();
          }
        }, _callee66, this, [[0, 7]]);
      }));
      function addPromoPlansToBasket(_x77, _x78, _x79) {
        return _addPromoPlansToBasket.apply(this, arguments);
      }
      return addPromoPlansToBasket;
    }()
  }, {
    key: "submitNCABasket",
    value: function () {
      var _submitNCABasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee67() {
        var _this3 = this;
        var params,
          _this$cache6,
          basketUserId,
          basketId,
          existingSIM,
          customerDetails,
          catalogId,
          selectedPlan,
          _registerUser,
          promoPlans,
          basket,
          planBillingMode,
          details,
          eliotJourney,
          prepaidSignUpProductLegacyId,
          signUpProducts,
          signUpProduct,
          extendedData,
          registerUserProducts,
          registerUserProduct,
          registerExtendedData,
          activationProducts,
          activationProduct,
          _args67 = arguments,
          _t44;
        return _regenerator["default"].wrap(function (_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              params = _args67.length > 0 && _args67[0] !== undefined ? _args67[0] : {};
              _context67.prev = 1;
              _this$cache6 = this.cache, basketUserId = _this$cache6.basketUserId, basketId = _this$cache6.basketId, existingSIM = _this$cache6.existingSIM, customerDetails = _this$cache6.customerDetails, catalogId = _this$cache6.catalogId, selectedPlan = _this$cache6.selectedPlan, _registerUser = _this$cache6.registerUser, promoPlans = _this$cache6.promoPlans;
              _context67.next = 2;
              return this.callApi('basket', 'getBasket', [basketUserId, basketId]);
            case 2:
              basket = _context67.sent;
              // based on the plan that was selected we either need the postpaid or prepaid sign up product
              // TODO currently hardcoded to postpaid item
              planBillingMode = selectedPlan && selectedPlan.billingMode;
              details = {
                "region": customerDetails.region,
                "personalDetails": {
                  "firstName": customerDetails.firstName,
                  "lastName": customerDetails.lastName,
                  "dob": new Date(customerDetails.dobYear + '-' + customerDetails.dobMonth + '-' + customerDetails.dobDay).toISOString(),
                  "emailAddress": customerDetails.email,
                  "contactNumber": customerDetails.phoneNumber,
                  "title": customerDetails.title,
                  "taxCode": customerDetails.taxCode
                },
                "deliveryAddress": {
                  "name": customerDetails.firstName + ' ' + customerDetails.lastName,
                  "addressLine1": customerDetails.address1,
                  "addressLine2": customerDetails.address2,
                  "city": customerDetails.city,
                  "state": customerDetails.county,
                  "country": "Mexico",
                  "zip": customerDetails.postcode,
                  "phoneNumber": customerDetails.phoneNumber
                },
                "identificationDetails": {
                  "identificationNumber": customerDetails.idNumber,
                  "identificationType": "ID"
                }
              };
              eliotJourney = params && params.partner === 'ELIOT';
              prepaidSignUpProductLegacyId = eliotJourney ? eliotSignUpLegacyId : prepaidSignUpLegId;
              _context67.next = 3;
              return function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (_registerUser) {
                  return _this3.callApi('catalog', 'getSignUpCustomerTechnicalOffers', [catalogId]);
                } else if (!planBillingMode || planBillingMode === prepaidBillingMode) {
                  // return this.catalog.getSignUpPrePaidCustomerProducts(catalogId)
                  return _this3.callApi('catalog', 'getSignUpPrePaidCustomerProducts', [catalogId]);
                } else {
                  return _this3.callApi('catalog', 'getSignUpPostPaidCustomerProducts', [catalogId]);
                  // return this.catalog.getSignUpPostPaidCustomerProducts(catalogId)
                }
              }();
            case 3:
              signUpProducts = _context67.sent;
              signUpProduct = function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (_registerUser) {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === appSignUpLegId;
                  });
                } else if (!planBillingMode || planBillingMode === prepaidBillingMode) {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === prepaidSignUpProductLegacyId;
                  });
                } else {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === postpaidSignUpLegId;
                  });
                }
              }(); // basket = await this.basket.getBasket(userId, basket.basketId)
              _context67.next = 4;
              return this.callApi('basket', 'getBasket', [basketUserId, basket.basketId]);
            case 4:
              basket = _context67.sent;
              extendedData = {
                // ...signUpProduct,
                accountNumber: details.region,
                personalDetails: details.personalDetails,
                deliveryAddress: details.deliveryAddress,
                // recurringPaymentDetails: details.recurringPaymentDetails,
                identificationDetails: details.identificationDetails,
                //TODO this needs to come from the cache or passed into this function
                receiptRequired: false
              };
              _context67.next = 5;
              return this.addAccountProductToBasket(basket, signUpProduct, extendedData);
            case 5:
              basket = _context67.sent;
              if (!_registerUser) {
                _context67.next = 10;
                break;
              }
              _context67.next = 6;
              return this.callApi('catalog', 'getRegisterUserTechnicalOffers', [catalogId]);
            case 6:
              registerUserProducts = _context67.sent;
              registerUserProduct = registerUserProducts.find(function (product) {
                return product.productLegacyId === registerUserLegacyId;
              });
              registerExtendedData = {
                registrationDetails: {
                  username: customerDetails.email,
                  operatorCode: 'VADSA',
                  dob: new Date(customerDetails.dobYear + '-' + customerDetails.dobMonth + '-' + customerDetails.dobDay).toISOString(),
                  firstName: customerDetails.firstName,
                  lastName: customerDetails.lastName,
                  emailAddress: customerDetails.email,
                  gender: customerDetails.title === 'Hombre' ? 'M' : 'F',
                  guest: false,
                  password: customerDetails.password,
                  primaryContactNumberCountryCode: '+52',
                  twoFactorAuthNumberCountryCode: '+52'
                }
              };
              _context67.next = 7;
              return this.addCustomerProductToBasket(basket, registerUserProduct, registerExtendedData);
            case 7:
              basket = _context67.sent;
              _context67.next = 8;
              return this.callApi('catalog', 'getModifyServiceDetailsProducts', [this.cache.catalogId]);
            case 8:
              activationProducts = _context67.sent;
              activationProduct = activationProducts.find(function (product) {
                return product.productLegacyId === _this3.configuration.activationProduct;
              });
              _context67.next = 9;
              return this.addServiceProductToBasket(basket, activationProduct);
            case 9:
              basket = _context67.sent;
            case 10:
              _context67.next = 11;
              return this.callApi('basket', 'getBasket', [basketUserId, basket.basketId]);
            case 11:
              basket = _context67.sent;
              _context67.next = 12;
              return this.confirmBasket(basket);
            case 12:
              basket = _context67.sent;
              return _context67.abrupt("return", basket);
            case 13:
              _context67.prev = 13;
              _t44 = _context67["catch"](1);
              throw _t44;
            case 14:
            case "end":
              return _context67.stop();
          }
        }, _callee67, this, [[1, 13]]);
      }));
      function submitNCABasket() {
        return _submitNCABasket.apply(this, arguments);
      }
      return submitNCABasket;
    }()
  }, {
    key: "submitNCABasketWithoutPlan",
    value: function () {
      var _submitNCABasketWithoutPlan = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee68() {
        var _this4 = this;
        var params,
          _this$cache7,
          basketUserId,
          basketId,
          existingSIM,
          customerDetails,
          catalogId,
          selectedPlan,
          _registerUser2,
          promoPlans,
          basket,
          basePlan,
          extendedDataServLevel,
          assignSimProducts,
          assignSimProduct,
          planBillingMode,
          details,
          eliotJourney,
          prepaidSignUpProductLegacyId,
          signUpProducts,
          signUpProduct,
          extendedData,
          registerUserProducts,
          registerUserProduct,
          registerExtendedData,
          activationProducts,
          activationProduct,
          _args68 = arguments,
          _t45;
        return _regenerator["default"].wrap(function (_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              params = _args68.length > 0 && _args68[0] !== undefined ? _args68[0] : {};
              _context68.prev = 1;
              _this$cache7 = this.cache, basketUserId = _this$cache7.basketUserId, basketId = _this$cache7.basketId, existingSIM = _this$cache7.existingSIM, customerDetails = _this$cache7.customerDetails, catalogId = _this$cache7.catalogId, selectedPlan = _this$cache7.selectedPlan, _registerUser2 = _this$cache7.registerUser, promoPlans = _this$cache7.promoPlans; // promtional addon gets added to the basket at the service level
              _context68.next = 2;
              return this.callApi('basket', 'getBasket', [basketUserId, basketId]);
            case 2:
              basket = _context68.sent;
              _context68.next = 3;
              return this.getBasePlan(catalogId);
            case 3:
              basePlan = _context68.sent;
              extendedDataServLevel = {};
              if (!existingSIM) {
                _context68.next = 6;
                break;
              }
              this.setCache({
                hasSimOrder: true
              });
              _context68.next = 4;
              return this.callApi('catalog', 'getAssignSimProducts', [catalogId]);
            case 4:
              assignSimProducts = _context68.sent;
              assignSimProduct = assignSimProducts.find(function (product) {
                return product.productLegacyId === assignSimLegacyId;
              });
              extendedDataServLevel = {
                ICCID: existingSIM
              };
              _context68.next = 5;
              return this.addServiceProductToBasket(basket, assignSimProduct, extendedDataServLevel);
            case 5:
              basket = _context68.sent;
            case 6:
              if (this.cache.referralCode) {
                extendedDataServLevel.agentReferalCode = this.cache.referralCode;
              }
              if (!(basePlan !== undefined)) {
                _context68.next = 8;
                break;
              }
              _context68.next = 7;
              return this.addServiceProductToBasket(basket, basePlan, extendedDataServLevel);
            case 7:
              basket = _context68.sent;
            case 8:
              // based on the plan that was selected we either need the postpaid or prepaid sign up product
              // TODO currently hardcoded to postpaid item
              planBillingMode = selectedPlan && selectedPlan.billingMode;
              details = {
                "region": customerDetails.region,
                "personalDetails": {
                  "firstName": customerDetails.firstName,
                  "lastName": customerDetails.lastName,
                  "dob": new Date(customerDetails.dobYear + '-' + customerDetails.dobMonth + '-' + customerDetails.dobDay).toISOString(),
                  "emailAddress": customerDetails.email,
                  "contactNumber": customerDetails.phoneNumber,
                  "title": customerDetails.title,
                  "taxCode": customerDetails.taxCode
                },
                "deliveryAddress": {
                  "name": customerDetails.firstName + ' ' + customerDetails.lastName,
                  "addressLine1": customerDetails.address1,
                  "addressLine2": customerDetails.address2,
                  "city": customerDetails.city,
                  "state": customerDetails.county,
                  "country": "Mexico",
                  "zip": customerDetails.postcode,
                  "phoneNumber": customerDetails.phoneNumber
                },
                "identificationDetails": {
                  "identificationNumber": customerDetails.idNumber,
                  "identificationType": "ID"
                }
              };
              eliotJourney = params && params.partner === 'ELIOT';
              prepaidSignUpProductLegacyId = eliotJourney ? eliotSignUpLegacyId : prepaidSignUpLegId;
              _context68.next = 9;
              return function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (_registerUser2) {
                  return _this4.callApi('catalog', 'getSignUpCustomerTechnicalOffers', [catalogId]);
                } else if (!planBillingMode || planBillingMode === prepaidBillingMode) {
                  // return this.catalog.getSignUpPrePaidCustomerProducts(catalogId)
                  return _this4.callApi('catalog', 'getSignUpPrePaidCustomerProducts', [catalogId]);
                } else {
                  return _this4.callApi('catalog', 'getSignUpPostPaidCustomerProducts', [catalogId]);
                  // return this.catalog.getSignUpPostPaidCustomerProducts(catalogId)
                }
              }();
            case 9:
              signUpProducts = _context68.sent;
              signUpProduct = function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (_registerUser2) {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === appSignUpLegId;
                  });
                } else if (!planBillingMode || planBillingMode === prepaidBillingMode) {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === prepaidSignUpProductLegacyId;
                  });
                } else {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === postpaidSignUpLegId;
                  });
                }
              }(); // basket = await this.basket.getBasket(userId, basket.basketId)
              _context68.next = 10;
              return this.callApi('basket', 'getBasket', [basketUserId, basket.basketId]);
            case 10:
              basket = _context68.sent;
              extendedData = {
                // ...signUpProduct,
                accountNumber: details.region,
                personalDetails: details.personalDetails,
                deliveryAddress: details.deliveryAddress,
                // recurringPaymentDetails: details.recurringPaymentDetails,
                identificationDetails: details.identificationDetails,
                //TODO this needs to come from the cache or passed into this function
                receiptRequired: false
              };
              _context68.next = 11;
              return this.addAccountProductToBasket(basket, signUpProduct, extendedData);
            case 11:
              basket = _context68.sent;
              if (!_registerUser2) {
                _context68.next = 16;
                break;
              }
              _context68.next = 12;
              return this.callApi('catalog', 'getRegisterUserTechnicalOffers', [catalogId]);
            case 12:
              registerUserProducts = _context68.sent;
              registerUserProduct = registerUserProducts.find(function (product) {
                return product.productLegacyId === registerUserLegacyId;
              });
              registerExtendedData = {
                registrationDetails: {
                  username: customerDetails.email,
                  operatorCode: 'VADSA',
                  dob: new Date(customerDetails.dobYear + '-' + customerDetails.dobMonth + '-' + customerDetails.dobDay).toISOString(),
                  firstName: customerDetails.firstName,
                  lastName: customerDetails.lastName,
                  emailAddress: customerDetails.email,
                  gender: customerDetails.title === 'Hombre' ? 'M' : 'F',
                  guest: false,
                  password: customerDetails.password,
                  primaryContactNumberCountryCode: '+52',
                  twoFactorAuthNumberCountryCode: '+52'
                }
              };
              _context68.next = 13;
              return this.addCustomerProductToBasket(basket, registerUserProduct, registerExtendedData);
            case 13:
              basket = _context68.sent;
              _context68.next = 14;
              return this.callApi('catalog', 'getModifyServiceDetailsProducts', [this.cache.catalogId]);
            case 14:
              activationProducts = _context68.sent;
              activationProduct = activationProducts.find(function (product) {
                return product.productLegacyId === _this4.configuration.activationProduct;
              });
              _context68.next = 15;
              return this.addServiceProductToBasket(basket, activationProduct);
            case 15:
              basket = _context68.sent;
            case 16:
              if (!promoPlans) {
                _context68.next = 18;
                break;
              }
              _context68.next = 17;
              return this.addPromoPlansToBasket(basket.basketId, basket.userId, promoPlans);
            case 17:
              basket = _context68.sent;
            case 18:
              _context68.next = 19;
              return this.callApi('basket', 'getBasket', [basketUserId, basket.basketId]);
            case 19:
              basket = _context68.sent;
              _context68.next = 20;
              return this.confirmBasket(basket);
            case 20:
              basket = _context68.sent;
              return _context68.abrupt("return", basket);
            case 21:
              _context68.prev = 21;
              _t45 = _context68["catch"](1);
              throw _t45;
            case 22:
            case "end":
              return _context68.stop();
          }
        }, _callee68, this, [[1, 21]]);
      }));
      function submitNCABasketWithoutPlan() {
        return _submitNCABasketWithoutPlan.apply(this, arguments);
      }
      return submitNCABasketWithoutPlan;
    }()
  }, {
    key: "submitNCAHostedPaymentBasket",
    value: function () {
      var _submitNCAHostedPaymentBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee69() {
        var params,
          _yield$this$createNCA,
          basketId,
          basketUserId,
          basket,
          _args69 = arguments,
          _t46;
        return _regenerator["default"].wrap(function (_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              params = _args69.length > 0 && _args69[0] !== undefined ? _args69[0] : {};
              _context69.prev = 1;
              if (!this.cache.basketSubmitted) {
                _context69.next = 3;
                break;
              }
              _context69.next = 2;
              return this.createNCABasket();
            case 2:
              _yield$this$createNCA = _context69.sent;
              basketId = _yield$this$createNCA.basketId;
              basketUserId = _yield$this$createNCA.basketUserId;
              this.setCache({
                basketId: basketId,
                basketUserId: basketUserId
              });
            case 3:
              _context69.next = 4;
              return this.submitNCABasket(params);
            case 4:
              basket = _context69.sent;
              this.setCache({
                basketSubmitted: true
              });
              _context69.next = 5;
              return this.payForBasketWithHostedPayment(basket);
            case 5:
              return _context69.abrupt("return", _context69.sent);
            case 6:
              _context69.prev = 6;
              _t46 = _context69["catch"](1);
              throw _t46;
            case 7:
            case "end":
              return _context69.stop();
          }
        }, _callee69, this, [[1, 6]]);
      }));
      function submitNCAHostedPaymentBasket() {
        return _submitNCAHostedPaymentBasket.apply(this, arguments);
      }
      return submitNCAHostedPaymentBasket;
    }()
  }, {
    key: "submitNCACashPaymentBasket",
    value: function () {
      var _submitNCACashPaymentBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee70() {
        var params,
          _yield$this$createNCA2,
          basketId,
          basketUserId,
          basket,
          cashPayment,
          _args70 = arguments,
          _t47;
        return _regenerator["default"].wrap(function (_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              params = _args70.length > 0 && _args70[0] !== undefined ? _args70[0] : {};
              _context70.prev = 1;
              if (!this.cache.basketSubmitted) {
                _context70.next = 3;
                break;
              }
              _context70.next = 2;
              return this.createNCABasket();
            case 2:
              _yield$this$createNCA2 = _context70.sent;
              basketId = _yield$this$createNCA2.basketId;
              basketUserId = _yield$this$createNCA2.basketUserId;
              this.setCache({
                basketId: basketId,
                basketUserId: basketUserId
              });
            case 3:
              _context70.next = 4;
              return this.submitNCABasket(params);
            case 4:
              basket = _context70.sent;
              this.setCache({
                basketSubmitted: true
              });
              _context70.next = 5;
              return this.payForBasketWithCash(basket);
            case 5:
              cashPayment = _context70.sent;
              return _context70.abrupt("return", {
                basket: basket,
                cashPayment: cashPayment
              });
            case 6:
              _context70.prev = 6;
              _t47 = _context70["catch"](1);
              throw _t47;
            case 7:
            case "end":
              return _context70.stop();
          }
        }, _callee70, this, [[1, 6]]);
      }));
      function submitNCACashPaymentBasket() {
        return _submitNCACashPaymentBasket.apply(this, arguments);
      }
      return submitNCACashPaymentBasket;
    }()
  }, {
    key: "submitNCANoPaymentBasket",
    value: function () {
      var _submitNCANoPaymentBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee71() {
        var params,
          basket,
          order,
          _args71 = arguments,
          _t48;
        return _regenerator["default"].wrap(function (_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              params = _args71.length > 0 && _args71[0] !== undefined ? _args71[0] : {};
              _context71.prev = 1;
              _context71.next = 2;
              return this.createNCABasket();
            case 2:
              basket = _context71.sent;
              this.setCache({
                basketUserId: basket.userId,
                basketId: basket.basketId
              });
              _context71.next = 3;
              return this.submitNCABasketWithoutPlan(params);
            case 3:
              basket = _context71.sent;
              _context71.next = 4;
              return this.processConfirmedBasketNoPayment(basket);
            case 4:
              order = _context71.sent;
              return _context71.abrupt("return", order);
            case 5:
              _context71.prev = 5;
              _t48 = _context71["catch"](1);
              throw _t48;
            case 6:
            case "end":
              return _context71.stop();
          }
        }, _callee71, this, [[1, 5]]);
      }));
      function submitNCANoPaymentBasket() {
        return _submitNCANoPaymentBasket.apply(this, arguments);
      }
      return submitNCANoPaymentBasket;
    }()
  }, {
    key: "checkoutNewCustomerWithPlan",
    value: function () {
      var _checkoutNewCustomerWithPlan = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee72(cardDetails) {
        var _this5 = this;
        var basket, order, _this$cache8, userId, customerId, catalogId, selectedPlan, customerDetails, existingSIM, basePlan, extendedDataServLevel, dispatchSimProducts, dispatchSimProduct, dispatchSimExtendedData, planBillingMode, details, signUpProducts, signUpProduct, extendedData, _t49;
        return _regenerator["default"].wrap(function (_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              _context72.next = 1;
              return this.signInWithUsernameAndPassword({
                username: 'VADSA-GUEST-ROOT',
                password: 'Passw001'
              });
            case 1:
              _context72.prev = 1;
              _this$cache8 = this.cache, userId = _this$cache8.userId, customerId = _this$cache8.customerId, catalogId = _this$cache8.catalogId, selectedPlan = _this$cache8.selectedPlan, customerDetails = _this$cache8.customerDetails, existingSIM = _this$cache8.existingSIM;
              this.unsetCache('hasSimOrder');

              // retrieve existing basket or create a new basket
              // basket = await this.basket.createBasket(userId)
              _context72.next = 2;
              return this.callApi('basket', 'createBasket', [userId]);
            case 2:
              basket = _context72.sent;
              _context72.next = 3;
              return this.getBasePlan(catalogId);
            case 3:
              basePlan = _context72.sent;
              extendedDataServLevel = {};
              if (existingSIM) {
                this.setCache({
                  hasSimOrder: true
                });
                extendedDataServLevel = {
                  ICCID: existingSIM
                };
              }
              if (this.cache.agent && this.cache.agent.user) {
                extendedDataServLevel.agentReferalCode = this.cache.agent.user.userName;
              }
              if (!(basePlan !== undefined)) {
                _context72.next = 5;
                break;
              }
              _context72.next = 4;
              return this.addServiceProductToBasket(basket, basePlan, extendedDataServLevel);
            case 4:
              basket = _context72.sent;
            case 5:
              if (existingSIM) {
                _context72.next = 8;
                break;
              }
              _context72.next = 6;
              return this.callApi('catalog', 'getDispatchSimProducts', [catalogId]);
            case 6:
              dispatchSimProducts = _context72.sent;
              dispatchSimProduct = dispatchSimProducts.find(function (product) {
                return product.productLegacyId === dispatchSimLegacyId;
              });
              dispatchSimExtendedData = {
                reason: "NewCustomer"
              };
              _context72.next = 7;
              return this.addServiceProductToBasket(basket, dispatchSimProduct, dispatchSimExtendedData);
            case 7:
              basket = _context72.sent;
            case 8:
              //if we have a recurring plan, then add the card details to the item in the basket
              //so that they can be correctly tokenised and sent through.
              if (selectedPlan.recurring) {
                extendedDataServLevel.CreditCard = {
                  cardDetails: {
                    cardNumber: (0, _utilities.encryptSensitiveString)(cardDetails.cardNumber, this.configuration.encryptionKey),
                    expiryDateMonth: cardDetails.expiryDateMonth,
                    expiryDateYear: cardDetails.expiryDateYear,
                    nameOnCard: cardDetails.nameOnCard,
                    last4Digits: cardDetails.cardNumber.substring(cardDetails.cardNumber.length - 4)
                  }
                };
              }
              // add the bundle add on to the basket at the service level
              _context72.next = 9;
              return this.addServiceProductToBasket(basket, selectedPlan, extendedDataServLevel);
            case 9:
              basket = _context72.sent;
              // based on the plan that was selected we either need the postpaid or prepaid sign up product
              // TODO currently hardcoded to postpaid item
              planBillingMode = selectedPlan.billingMode;
              details = {
                "region": customerDetails.region,
                "personalDetails": {
                  "firstName": customerDetails.firstName,
                  "lastName": customerDetails.lastName,
                  "dob": new Date(customerDetails.dobYear + '-' + customerDetails.dobMonth + '-' + customerDetails.dobDay).toISOString(),
                  "emailAddress": customerDetails.email,
                  "contactNumber": customerDetails.phoneNumber,
                  "title": customerDetails.title,
                  "taxCode": customerDetails.taxCode
                },
                "deliveryAddress": {
                  "name": customerDetails.firstName + ' ' + customerDetails.lastName,
                  "addressLine1": customerDetails.address1,
                  "addressLine2": customerDetails.address2,
                  "city": customerDetails.city,
                  "state": customerDetails.county,
                  "country": "Mexico",
                  "zip": customerDetails.postcode,
                  "phoneNumber": customerDetails.phoneNumber
                },
                "recurringPaymentDetails": planBillingMode === prepaidBillingMode ? {} : {
                  "directDebitDetails": {
                    "bankAccountNumber": "01068009",
                    "branchSortCode": "804718",
                    "nameOnAccount": cardDetails.nameOnCard
                  }
                },
                "oneOffPaymentDetails": {
                  "cardDetails": {
                    "cardNumber": cardDetails.cardNumber
                  }
                },
                "identificationDetails": {
                  "identificationNumber": customerDetails.idNumber,
                  "identificationType": "ID"
                }
              };
              _context72.next = 10;
              return function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (planBillingMode === prepaidBillingMode) {
                  // return this.catalog.getSignUpPrePaidCustomerProducts(catalogId)
                  return _this5.callApi('catalog', 'getSignUpPrePaidCustomerProducts', [catalogId]);
                } else {
                  // return this.catalog.getSignUpPostPaidCustomerProducts(catalogId)
                  return _this5.callApi('catalog', 'getSignUpPostPaidCustomerProducts', [catalogId]);
                }
              }();
            case 10:
              signUpProducts = _context72.sent;
              signUpProduct = function () {
                //if (planBillingMode === this.configuration.prepaidBillingMode){
                if (planBillingMode === prepaidBillingMode) {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === prepaidSignUpLegId;
                  });
                } else {
                  return signUpProducts.find(function (product) {
                    return product.productLegacyId === postpaidSignUpLegId;
                  });
                }
              }(); // basket = await this.basket.getBasket(userId, basket.basketId)
              _context72.next = 11;
              return this.callApi('basket', 'getBasket', [userId, basket.basketId]);
            case 11:
              basket = _context72.sent;
              _context72.next = 12;
              return this.addAccountProductToBasket(basket, signUpProduct);
            case 12:
              basket = _context72.sent;
              extendedData = _objectSpread(_objectSpread({}, signUpProduct), {}, {
                accountNumber: details.region,
                personalDetails: details.personalDetails,
                deliveryAddress: details.deliveryAddress,
                recurringPaymentDetails: details.recurringPaymentDetails,
                identificationDetails: details.identificationDetails,
                //TODO this needs to come from the cache or passed into this function
                receiptRequired: false
              });
              _context72.next = 13;
              return this.addExtendedDataToAccountItem(basket, signUpProduct.productId, extendedData);
            case 13:
              basket = _context72.sent;
              _context72.next = 14;
              return this.callApi('basket', 'getBasket', [userId, basket.basketId]);
            case 14:
              basket = _context72.sent;
              _context72.next = 15;
              return this.confirmBasket(basket);
            case 15:
              basket = _context72.sent;
              _context72.next = 16;
              return this.payForBasketWithCreditCard(basket, cardDetails);
            case 16:
              order = _context72.sent;
              _context72.next = 17;
              return this.pollOrderForStatus(customerId, order.orderId);
            case 17:
              order = _context72.sent;
              //only clear cache if order was successful, to give the customer the chance to retry otherwise.
              if (order && (order.status === 'successful' || order.status === 'awaiting-sim')) {
                this.clearBasketCache({
                  orderId: order.orderId,
                  order: order
                });
                this.unsetCache('existingSIM');
              }
              return _context72.abrupt("return", order);
            case 18:
              _context72.prev = 18;
              _t49 = _context72["catch"](1);
              throw _t49;
            case 19:
            case "end":
              return _context72.stop();
          }
        }, _callee72, this, [[1, 18]]);
      }));
      function checkoutNewCustomerWithPlan(_x80) {
        return _checkoutNewCustomerWithPlan.apply(this, arguments);
      }
      return checkoutNewCustomerWithPlan;
    }()
  }, {
    key: "createHostedPaymentForServiceProduct",
    value: function () {
      var _createHostedPaymentForServiceProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee73(product, extendedData) {
        var basket, response, _t50;
        return _regenerator["default"].wrap(function (_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _context73.prev = 0;
              _context73.next = 1;
              return this.createBasket();
            case 1:
              basket = _context73.sent;
              _context73.next = 2;
              return this.addServiceProductToBasket(basket, product, extendedData);
            case 2:
              basket = _context73.sent;
              _context73.next = 3;
              return this.confirmBasket(basket);
            case 3:
              basket = _context73.sent;
              console.log('createHostedPaymentForServiceProduct - using hosted payment with basket', JSON.stringify(basket, null, 2));
              _context73.next = 4;
              return this.payForBasketWithHostedPayment(basket, 'stripe');
            case 4:
              response = _context73.sent;
              console.log('createHostedPaymentForServiceProduct - JUST BASKET REF ID', JSON.stringify(response, null, 2));
              return _context73.abrupt("return", response);
            case 5:
              _context73.prev = 5;
              _t50 = _context73["catch"](0);
              throw _t50;
            case 6:
            case "end":
              return _context73.stop();
          }
        }, _callee73, this, [[0, 5]]);
      }));
      function createHostedPaymentForServiceProduct(_x81, _x82) {
        return _createHostedPaymentForServiceProduct.apply(this, arguments);
      }
      return createHostedPaymentForServiceProduct;
    }()
  }, {
    key: "createHostedPaymentForCustomerProduct",
    value: function () {
      var _createHostedPaymentForCustomerProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee74(product, extendedData) {
        var basket, response, _t51;
        return _regenerator["default"].wrap(function (_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.prev = 0;
              _context74.next = 1;
              return this.createBasket();
            case 1:
              basket = _context74.sent;
              _context74.next = 2;
              return this.addCustomerProductToBasket(basket, product, extendedData);
            case 2:
              basket = _context74.sent;
              _context74.next = 3;
              return this.confirmBasket(basket);
            case 3:
              basket = _context74.sent;
              console.log('createHostedPaymentForCustomerProduct - using hosted payment with basket', JSON.stringify(basket, null, 2));
              _context74.next = 4;
              return this.payForBasketWithHostedPayment(basket, 'stripe');
            case 4:
              response = _context74.sent;
              console.log('createHostedPaymentForCustomerProduct - JUST BASKET REF ID', JSON.stringify(response, null, 2));
              return _context74.abrupt("return", response);
            case 5:
              _context74.prev = 5;
              _t51 = _context74["catch"](0);
              throw _t51;
            case 6:
            case "end":
              return _context74.stop();
          }
        }, _callee74, this, [[0, 5]]);
      }));
      function createHostedPaymentForCustomerProduct(_x83, _x84) {
        return _createHostedPaymentForCustomerProduct.apply(this, arguments);
      }
      return createHostedPaymentForCustomerProduct;
    }()
  }, {
    key: "checkoutServiceProduct",
    value: function () {
      var _checkoutServiceProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee75(product, extendedData) {
        var paymentType,
          basket,
          order,
          _args75 = arguments,
          _t52;
        return _regenerator["default"].wrap(function (_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              paymentType = _args75.length > 2 && _args75[2] !== undefined ? _args75[2] : 'noPayment';
              _context75.prev = 1;
              _context75.next = 2;
              return this.createBasket();
            case 2:
              basket = _context75.sent;
              _context75.next = 3;
              return this.addServiceProductToBasket(basket, product, extendedData);
            case 3:
              basket = _context75.sent;
              _context75.next = 4;
              return this.confirmBasket(basket);
            case 4:
              basket = _context75.sent;
              if (!(paymentType === 'hostedPayment')) {
                _context75.next = 8;
                break;
              }
              console.log('checkoutServiceProduct - using hosted payment with basket', JSON.stringify(basket, null, 2));
              _context75.next = 5;
              return this.payForBasketWithHostedPayment(basket, 'stripe');
            case 5:
              order = _context75.sent;
              console.log('checkoutServiceProduct - JUST BASKET REF ID', JSON.stringify(order, null, 2));
              //we will get back an object with basket ref ID, we need to use this to get the order
              if (!(order && order.basketRefId)) {
                _context75.next = 7;
                break;
              }
              _context75.next = 6;
              return this.getOrder(order.basketRefId);
            case 6:
              order = _context75.sent;
            case 7:
              console.log('checkoutServiceProduct - order after FULL RETRIEVAL', JSON.stringify(order, null, 2));
              _context75.next = 10;
              break;
            case 8:
              _context75.next = 9;
              return this.processConfirmedBasketNoPayment(basket);
            case 9:
              order = _context75.sent;
            case 10:
              _context75.next = 11;
              return this.pollOrderForStatus(this.cache.customerId, order.orderId);
            case 11:
              order = _context75.sent;
              this.unsetCache('currentBasketId');
              this.unsetCache('basket');
              return _context75.abrupt("return", order);
            case 12:
              _context75.prev = 12;
              _t52 = _context75["catch"](1);
              throw _t52;
            case 13:
            case "end":
              return _context75.stop();
          }
        }, _callee75, this, [[1, 12]]);
      }));
      function checkoutServiceProduct(_x85, _x86) {
        return _checkoutServiceProduct.apply(this, arguments);
      }
      return checkoutServiceProduct;
    }()
  }, {
    key: "checkoutServiceDelProduct",
    value: function () {
      var _checkoutServiceDelProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee76(product, extendedData) {
        var basket, order, _t53;
        return _regenerator["default"].wrap(function (_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              _context76.prev = 0;
              _context76.next = 1;
              return this.createBasket();
            case 1:
              basket = _context76.sent;
              _context76.next = 2;
              return this.addDeleteServiceProductToBasket(basket, product, extendedData);
            case 2:
              basket = _context76.sent;
              _context76.next = 3;
              return this.confirmBasket(basket);
            case 3:
              basket = _context76.sent;
              _context76.next = 4;
              return this.processConfirmedBasketNoPayment(basket);
            case 4:
              order = _context76.sent;
              _context76.next = 5;
              return this.pollOrderForStatus(this.cache.customerId, order.orderId);
            case 5:
              order = _context76.sent;
              this.unsetCache('currentBasketId');
              this.unsetCache('basket');
              return _context76.abrupt("return", order);
            case 6:
              _context76.prev = 6;
              _t53 = _context76["catch"](0);
              throw _t53;
            case 7:
            case "end":
              return _context76.stop();
          }
        }, _callee76, this, [[0, 6]]);
      }));
      function checkoutServiceDelProduct(_x87, _x88) {
        return _checkoutServiceDelProduct.apply(this, arguments);
      }
      return checkoutServiceDelProduct;
    }()
  }, {
    key: "checkoutCustomerProduct",
    value: function () {
      var _checkoutCustomerProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee77(product, extendedData) {
        var options,
          basket,
          order,
          start,
          stepStart,
          _args77 = arguments,
          _t54;
        return _regenerator["default"].wrap(function (_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              options = _args77.length > 2 && _args77[2] !== undefined ? _args77[2] : {};
              start = Date.now();
              _context77.prev = 1;
              stepStart = Date.now();
              _context77.next = 2;
              return this.createBasket();
            case 2:
              basket = _context77.sent;
              console.log("[checkoutCustomerProduct] createBasket took ".concat(Date.now() - stepStart, "ms"));
              stepStart = Date.now();
              _context77.next = 3;
              return this.addCustomerProductToBasket(basket, product, extendedData);
            case 3:
              basket = _context77.sent;
              console.log("[checkoutCustomerProduct] addCustomerProductToBasket took ".concat(Date.now() - stepStart, "ms"));
              stepStart = Date.now();
              _context77.next = 4;
              return this.confirmBasket(basket);
            case 4:
              basket = _context77.sent;
              console.log("[checkoutCustomerProduct] confirmBasket took ".concat(Date.now() - stepStart, "ms"));
              stepStart = Date.now();
              _context77.next = 5;
              return this.processConfirmedBasketNoPayment(basket);
            case 5:
              order = _context77.sent;
              console.log("[checkoutCustomerProduct] processConfirmedBasketNoPayment took ".concat(Date.now() - stepStart, "ms"));
              stepStart = Date.now();
              _context77.next = 6;
              return this.pollOrderForStatus(this.cache.customerId, order.orderId, undefined, 0, {
                mode: options.pollMode || 'standard'
              });
            case 6:
              order = _context77.sent;
              console.log("[checkoutCustomerProduct] pollOrderForStatus took ".concat(Date.now() - stepStart, "ms"));
              this.unsetCache('currentBasketId');
              this.unsetCache('basket');
              console.log("[checkoutCustomerProduct] total took ".concat(Date.now() - start, "ms"));
              return _context77.abrupt("return", order);
            case 7:
              _context77.prev = 7;
              _t54 = _context77["catch"](1);
              console.log("[checkoutCustomerProduct] failed after ".concat(Date.now() - start, "ms"));
              throw _t54;
            case 8:
            case "end":
              return _context77.stop();
          }
        }, _callee77, this, [[1, 7]]);
      }));
      function checkoutCustomerProduct(_x89, _x90) {
        return _checkoutCustomerProduct.apply(this, arguments);
      }
      return checkoutCustomerProduct;
    }()
  }, {
    key: "checkoutAccountProduct",
    value: function () {
      var _checkoutAccountProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee78(product, extendedData) {
        var basket, order, _t55;
        return _regenerator["default"].wrap(function (_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              _context78.prev = 0;
              _context78.next = 1;
              return this.createBasket();
            case 1:
              basket = _context78.sent;
              _context78.next = 2;
              return this.addAccountProductToBasket(basket, product, extendedData);
            case 2:
              basket = _context78.sent;
              _context78.next = 3;
              return this.confirmBasket(basket);
            case 3:
              basket = _context78.sent;
              _context78.next = 4;
              return this.processConfirmedBasketNoPayment(basket);
            case 4:
              order = _context78.sent;
              _context78.next = 5;
              return this.pollOrderForStatus(this.cache.customerId, order.orderId);
            case 5:
              order = _context78.sent;
              this.unsetCache('currentBasketId');
              this.unsetCache('basket');
              return _context78.abrupt("return", order);
            case 6:
              _context78.prev = 6;
              _t55 = _context78["catch"](0);
              throw _t55;
            case 7:
            case "end":
              return _context78.stop();
          }
        }, _callee78, this, [[0, 6]]);
      }));
      function checkoutAccountProduct(_x91, _x92) {
        return _checkoutAccountProduct.apply(this, arguments);
      }
      return checkoutAccountProduct;
    }()
  }, {
    key: "getBasePlan",
    value: function () {
      var _getBasePlan = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee79(catalogId) {
        var plans;
        return _regenerator["default"].wrap(function (_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 1;
              return this.callApi('catalog', 'getPlansProducts', [catalogId]);
            case 1:
              plans = _context79.sent;
              return _context79.abrupt("return", plans.find(function (plan) {
                return plan.productLegacyId === basePrepaidPlan;
              }));
            case 2:
            case "end":
              return _context79.stop();
          }
        }, _callee79, this);
      }));
      function getBasePlan(_x93) {
        return _getBasePlan.apply(this, arguments);
      }
      return getBasePlan;
    }()
  }, {
    key: "addDeleteServiceProductToBasket",
    value: function () {
      var _addDeleteServiceProductToBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee80(basket, product, extendedData) {
        var basketItem, updatedBasket;
        return _regenerator["default"].wrap(function (_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              //build up a basket item from the product
              basketItem = this.createBasketItemFromProduct(product, true, true, extendedData);
              basket.serviceDelItems.push(basketItem);
              //Set the extra fields on the basket
              basket.channel = this.configuration.channelName;
              basket.currency = product.currency;
              basket.customerId = this.cache.customerId;
              basket.message = "Deleting Product " + product.category;
              basket.subTotal = basket.subTotal || 0;
              basket.total = basket.total || 0;
              basket.unit = product.costUnit;
              basket.vat = basket.vat || 0;

              // const updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context80.next = 1;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 1:
              updatedBasket = _context80.sent;
              return _context80.abrupt("return", updatedBasket);
            case 2:
            case "end":
              return _context80.stop();
          }
        }, _callee80, this);
      }));
      function addDeleteServiceProductToBasket(_x94, _x95, _x96) {
        return _addDeleteServiceProductToBasket.apply(this, arguments);
      }
      return addDeleteServiceProductToBasket;
    }()
  }, {
    key: "checkoutServiceProducts",
    value: function () {
      var _checkoutServiceProducts = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee81(productsWithExtendedData) {
        var basket, order, i, _productsWithExtended, product, extendedData, basketItem, updatedBasket, confirmedBasket, _t56;
        return _regenerator["default"].wrap(function (_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _context81.prev = 0;
              _context81.next = 1;
              return this.createBasket();
            case 1:
              basket = _context81.sent;
              for (i in productsWithExtendedData) {
                _productsWithExtended = productsWithExtendedData[i], product = _productsWithExtended.product, extendedData = _productsWithExtended.extendedData;
                basketItem = this.createBasketItemFromProduct(product, true, true, extendedData);
                basket.serviceItems.push(basketItem);
              }

              // enrich the basket
              basket.channel = this.configuration.channelName;
              basket.customerId = this.cache.customerId;
              basket.message = "Purchasing Products";
              basket.subTotal = 0;
              basket.total = 0;
              basket.vat = 0;

              // var updatedBasket = await this.basket.modifyBasket(basket.userId, basket.basketId, basket)
              _context81.next = 2;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 2:
              updatedBasket = _context81.sent;
              _context81.next = 3;
              return this.confirmBasket(updatedBasket);
            case 3:
              confirmedBasket = _context81.sent;
              _context81.next = 4;
              return this.processConfirmedBasketNoPayment(confirmedBasket);
            case 4:
              order = _context81.sent;
              _context81.next = 5;
              return this.pollOrderForStatus(this.cache.customerId, order.orderId);
            case 5:
              order = _context81.sent;
              this.unsetCache('currentBasketId');
              this.unsetCache('basket');
              return _context81.abrupt("return", order);
            case 6:
              _context81.prev = 6;
              _t56 = _context81["catch"](0);
              throw _t56;
            case 7:
            case "end":
              return _context81.stop();
          }
        }, _callee81, this, [[0, 6]]);
      }));
      function checkoutServiceProducts(_x97) {
        return _checkoutServiceProducts.apply(this, arguments);
      }
      return checkoutServiceProducts;
    }() //Activates a service - 
  }, {
    key: "activateService",
    value: function () {
      var _activateService = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee82(customerId) {
        var _this6 = this;
        var extendedData,
          activationProduct,
          bundleProductId,
          paymentType,
          startTime,
          activationProducts,
          basket,
          order,
          addOnProduct,
          addOnProducts,
          basketRefId,
          _args82 = arguments,
          _t57;
        return _regenerator["default"].wrap(function (_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              extendedData = _args82.length > 1 && _args82[1] !== undefined ? _args82[1] : undefined;
              activationProduct = _args82.length > 2 && _args82[2] !== undefined ? _args82[2] : undefined;
              bundleProductId = _args82.length > 3 && _args82[3] !== undefined ? _args82[3] : undefined;
              paymentType = _args82.length > 4 && _args82[4] !== undefined ? _args82[4] : 'noPayment';
              //get the account and service from the customer
              console.log('Activating service for customer:', customerId);
              console.log('with Extended Data:', JSON.stringify(extendedData, null, 2));
              startTime = Date.now();
              _context82.next = 1;
              return this.cacheUserAccountInformation(customerId);
            case 1:
              if (activationProduct) {
                _context82.next = 3;
                break;
              }
              _context82.next = 2;
              return this.callApi('catalog', 'getModifyServiceDetailsProducts', [this.cache.catalogId]);
            case 2:
              activationProducts = _context82.sent;
              activationProduct = activationProducts.find(function (product) {
                return product.productLegacyId === _this6.configuration.activationProduct;
              });
            case 3:
              addOnProduct = undefined;
              _context82.prev = 4;
              if (!(bundleProductId !== undefined)) {
                _context82.next = 6;
                break;
              }
              _context82.next = 5;
              return this.callApi('catalog', 'getAddOnsProducts', [this.cache.catalogId]);
            case 5:
              addOnProducts = _context82.sent;
              addOnProduct = addOnProducts.find(function (product) {
                return product.productId === bundleProductId;
              });
            case 6:
              _context82.next = 7;
              return this.createBasket();
            case 7:
              basket = _context82.sent;
              _context82.next = 8;
              return this.addServiceProductToBasket(basket, activationProduct, extendedData);
            case 8:
              basket = _context82.sent;
              if (!(addOnProduct !== undefined)) {
                _context82.next = 10;
                break;
              }
              _context82.next = 9;
              return this.addServiceProductToBasket(basket, addOnProduct);
            case 9:
              basket = _context82.sent;
            case 10:
              _context82.next = 11;
              return this.confirmBasket(basket);
            case 11:
              basket = _context82.sent;
              if (!(paymentType === 'hostedPayment')) {
                _context82.next = 19;
                break;
              }
              _context82.next = 12;
              return this.payForBasketWithHostedPayment(basket, 'stripe');
            case 12:
              order = _context82.sent;
              console.log('activateService - order after hosted payment', JSON.stringify(order, null, 2));
              if (!(order && order.basketRefId)) {
                _context82.next = 14;
                break;
              }
              basketRefId = order.basketRefId;
              _context82.next = 13;
              return this.getOrder(basketRefId);
            case 13:
              order = _context82.sent;
              console.log('activateService - order after FULL RETRIEVAL', JSON.stringify(order, null, 2));
            case 14:
              if (!(order === null && startTime + this.apiTimeout > Date.now())) {
                _context82.next = 17;
                break;
              }
              _context82.next = 15;
              return (0, _delay["default"])(2000);
            case 15:
              _context82.next = 16;
              return this.getOrder(basketRefId);
            case 16:
              order = _context82.sent;
              console.log('activateService - order in loop', JSON.stringify(order, null, 2));
              _context82.next = 14;
              break;
            case 17:
              if (!(order === null)) {
                _context82.next = 18;
                break;
              }
              throw {
                response: {
                  body: {
                    messageCode: 'SR9999',
                    message: 'Timeout Reached waiting for order creation in Activate Service'
                  }
                }
              };
            case 18:
              _context82.next = 21;
              break;
            case 19:
              _context82.next = 20;
              return this.processConfirmedBasketNoPayment(basket);
            case 20:
              order = _context82.sent;
            case 21:
              _context82.next = 22;
              return this.pollOrderForStatus(this.cache.customerId, order.orderId);
            case 22:
              order = _context82.sent;
              this.unsetCache('currentBasketId');
              this.unsetCache('basket');
              _context82.next = 24;
              break;
            case 23:
              _context82.prev = 23;
              _t57 = _context82["catch"](4);
              console.error('Error during service activation:', _t57);
              throw _t57;
            case 24:
              return _context82.abrupt("return", order);
            case 25:
            case "end":
              return _context82.stop();
          }
        }, _callee82, this, [[4, 23]]);
      }));
      function activateService(_x98) {
        return _activateService.apply(this, arguments);
      }
      return activateService;
    }() //Create a cache basket so we can handle multiple items
  }, {
    key: "addToCacheBasket",
    value: function () {
      var _addToCacheBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee83(product) {
        var basket, updatedBasket;
        return _regenerator["default"].wrap(function (_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              basket = this.cache.basket;
              if (!(basket === undefined || basket.serviceItems === undefined || basket.serviceItems.length === 0)) {
                _context83.next = 3;
                break;
              }
              _context83.next = 1;
              return this.createBasket();
            case 1:
              updatedBasket = _context83.sent;
              _context83.next = 2;
              return this.addServiceProductToBasket(updatedBasket, product);
            case 2:
              updatedBasket = _context83.sent;
              _context83.next = 5;
              break;
            case 3:
              _context83.next = 4;
              return this.addServiceProductToBasket(basket, product);
            case 4:
              updatedBasket = _context83.sent;
            case 5:
              this.setCache({
                basket: updatedBasket
              });
              return _context83.abrupt("return", updatedBasket);
            case 6:
            case "end":
              return _context83.stop();
          }
        }, _callee83, this);
      }));
      function addToCacheBasket(_x99) {
        return _addToCacheBasket.apply(this, arguments);
      }
      return addToCacheBasket;
    }() //Clear the cache basket
  }, {
    key: "clearCacheBasket",
    value: function () {
      var _clearCacheBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee84() {
        var basket, updatedBasket;
        return _regenerator["default"].wrap(function (_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              basket = this.cache.basket;
              if (!(basket !== undefined && basket.serviceItems.length > 0)) {
                _context84.next = 2;
                break;
              }
              basket.serviceItems = [];
              _context84.next = 1;
              return this.callApi('basket', 'modifyBasket', [basket.userId, basket.basketId, basket]);
            case 1:
              updatedBasket = _context84.sent;
              this.setCache({
                basket: updatedBasket
              });
            case 2:
            case "end":
              return _context84.stop();
          }
        }, _callee84, this);
      }));
      function clearCacheBasket() {
        return _clearCacheBasket.apply(this, arguments);
      }
      return clearCacheBasket;
    }()
  }, {
    key: "recreateBasket",
    value: function () {
      var _recreateBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee85(oldBasket) {
        var newBasket, i;
        return _regenerator["default"].wrap(function (_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              _context85.next = 1;
              return this.createBasket();
            case 1:
              newBasket = _context85.sent;
              i = 0;
            case 2:
              if (!(i < oldBasket.serviceItems.length)) {
                _context85.next = 5;
                break;
              }
              _context85.next = 3;
              return this.addToCacheBasket(oldBasket.serviceItems[i]);
            case 3:
              newBasket = _context85.sent;
            case 4:
              i++;
              _context85.next = 2;
              break;
            case 5:
              return _context85.abrupt("return", newBasket);
            case 6:
            case "end":
              return _context85.stop();
          }
        }, _callee85, this);
      }));
      function recreateBasket(_x100) {
        return _recreateBasket.apply(this, arguments);
      }
      return recreateBasket;
    }()
  }, {
    key: "removeProductFromBasket",
    value: function () {
      var _removeProductFromBasket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee86(product) {
        var basket, i;
        return _regenerator["default"].wrap(function (_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              basket = this.cache.basket;
              for (i = 0; i < this.cache.basket.serviceItems.length; i++) {
                if (this.cache.basket[i] === product) {
                  this.cache.basket.splice(i, 1);
                }
              }
            case 1:
            case "end":
              return _context86.stop();
          }
        }, _callee86, this);
      }));
      function removeProductFromBasket(_x101) {
        return _removeProductFromBasket.apply(this, arguments);
      }
      return removeProductFromBasket;
    }() //Add cached payment method
  }, {
    key: "setCachedPayment",
    value: function setCachedPayment(paymentProduct) {
      if (this.cache.cachedPayment !== undefined) {
        this.cache.cachedPayment = paymentProduct;
      } else {
        var cache = {};
        cache.cachedPayment = paymentProduct;
        this.setCache(cache);
      }
    }

    //Clear the cache basket
  }, {
    key: "clearCachedPayment",
    value: function clearCachedPayment() {
      this.cache.cachedPayment = undefined;
    }

    //Wrapper function to make API calls and handle generic errors (token expired, Upgrade needed)
  }, {
    key: "callApi",
    value: function () {
      var _callApi = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee87(api, apiName) {
        var parameters,
          startTime,
          _this$api,
          response,
          _response,
          _response2,
          _args87 = arguments,
          _t58,
          _t59;
        return _regenerator["default"].wrap(function (_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              parameters = _args87.length > 2 && _args87[2] !== undefined ? _args87[2] : [];
              startTime = _args87.length > 3 ? _args87[3] : undefined;
              if (startTime === undefined) {
                startTime = Date.now();
              }
              if (!(typeof this[api][apiName] === "function")) {
                _context87.next = 14;
                break;
              }
              _context87.prev = 1;
              _context87.next = 2;
              return (_this$api = this[api])[apiName].apply(_this$api, (0, _toConsumableArray2["default"])(parameters));
            case 2:
              response = _context87.sent;
              return _context87.abrupt("return", response);
            case 3:
              _context87.prev = 3;
              _t58 = _context87["catch"](1);
              if (!(startTime + this.apiTimeout < Date.now())) {
                _context87.next = 4;
                break;
              }
              throw {
                response: {
                  body: {
                    messageCode: 'SR9999',
                    message: 'Timeout Reached'
                  }
                }
              };
            case 4:
              if (!(_t58.status === 401 && _t58.response !== undefined && _t58.response.body !== undefined && (_t58.response.body.messageCode === 'SR0012' || _t58.response.body.code === 'TOKEN_EXPIRED'))) {
                _context87.next = 9;
                break;
              }
              _context87.prev = 5;
              _context87.next = 6;
              return this.refreshToken(startTime);
            case 6:
              _context87.next = 7;
              return this.callApi(api, apiName, parameters, startTime);
            case 7:
              _response = _context87.sent;
              return _context87.abrupt("return", _response);
            case 8:
              _context87.prev = 8;
              _t59 = _context87["catch"](5);
              if (_t59.response !== undefined && _t59.response.body !== undefined && (_t59.response.body.messageCode === 'SR0004' || _t59.response.body.code === 'USER_LOCKED')) {
                if (this.configuration.logoutFunction && typeof this.configuration.logoutFunction === "function") {
                  this.configuration.logoutFunction();
                }
              }
              _context87.next = 14;
              break;
            case 9:
              if (!(_t58.response && _t58.response.body && (_t58.response.body.messageCode === "SR0043" || _t58.response.body.code === 'API_CLIENT_VERSION_NOT_SUPPORTED'))) {
                _context87.next = 10;
                break;
              }
              //Need upgrade, log customer out with error message
              if (this.configuration.logoutFunction && typeof this.configuration.logoutFunction === "function") {
                this.configuration.logoutFunction();
              }
              throw _t58;
            case 10:
              if (!(_t58.response && _t58.response.body && (_t58.response.body.messageCode === "SR00043" || _t58.response.body.code === 'DATA_SYNCHRONISING'))) {
                _context87.next = 13;
                break;
              }
              _context87.next = 11;
              return (0, _delay["default"])(this.customerRefreshTime);
            case 11:
              _context87.next = 12;
              return this.callApi(api, apiName, parameters, startTime);
            case 12:
              _response2 = _context87.sent;
              return _context87.abrupt("return", _response2);
            case 13:
              throw _t58;
            case 14:
            case "end":
              return _context87.stop();
          }
        }, _callee87, this, [[1, 3], [5, 8]]);
      }));
      function callApi(_x102, _x103) {
        return _callApi.apply(this, arguments);
      }
      return callApi;
    }()
  }]);
}(); // Extend Client class with generated client classes
// e.g. var api = new client.ApiClient()
// Object.assign(Client, apis)
// Filter only the api calls e.g. CustomerApi
// Filter deprecated api calls e.g. ZTheCustomerAPIApi
(0, _defineProperty2["default"])(Client, "api", void 0);
(0, _defineProperty2["default"])(Client, "orderRefreshTime", 5000);
(0, _defineProperty2["default"])(Client, "orderRefreshTimeout", 600000);
(0, _defineProperty2["default"])(Client, "apiTimeout", 60000);
(0, _defineProperty2["default"])(Client, "timeoutReachedCode", 408);
(0, _defineProperty2["default"])(Client, "balanceTimeStamp", Date.now());
(0, _defineProperty2["default"])(Client, "configuration", void 0);
var apiKeys = Object.keys(_apis["default"]).filter(function (key) {
  return key.substring(key.length - 3, key.length) === 'Api';
}).filter(function (key) {
  return key.substring(0, 4) !== 'ZThe';
});

// Extend the class with a reflection of clients api calls
/* .e.g:

  var accounts = client.accounts.getAccounts({})

 * Same as:

  var api = new ClientApi()
  var account = new AccountApi(api)
  var accounts = await account.getAccounts({})

 *
 */
var _iterator = _createForOfIteratorHelper(apiKeys),
  _step;
try {
  var _loop = function _loop() {
    var key = _step.value;
    var name = key.slice(0, key.length - 3);
    var camelName = name.charAt(0).toLowerCase() + name.slice(1);
    Object.defineProperty(Client, camelName, {
      enumerable: true,
      get: function get() {
        return new _apis["default"][key](Client.api);
      }
    });
  };
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    _loop();
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}
Client.setupApi();

// For debugging in development mode
if (process.env.NODE_ENV === "development") {
  if (window) window.client = Client;
}